export const data = {
  "nodes": [
    {
      "id": "Addiction friction",
      "tldr": [
        "Dopamine is often described as a “feel-good” chemical, but its deeper role is regulation — not pleasure. It governs motivation, learning, attachment, and how the brain adapts to its environment. In conditions of scarcity, this system evolved to keep humans alive. In conditions of abundance, the same system becomes stressed. What emerges is not excess pleasure, but instability: craving, numbness, and loss of agency."
      ],
      "connections": [
        "Sweet and salty sugar",
        "Unmanned man",
        "Out of focus",
        "Brain health 101",
        "Brainiac strategies for the brain",
        "Mind at volume",
        "Socialized wellness"
      ],
      "url": "https://wellawarecare.substack.com/p/addiction-friction"
    },
    {
      "id": "Alcohol & DNA",
      "tldr": [
        "Alcohol alters DNA methylation, disrupting gene expression and elevating cancer risks, especially breast cancer. ",
        "Fetal alcohol exposure causes severe, irreversible developmental damage. ",
        "Chronic drinking disturbs hormonal balance, converting testosterone into estrogen, increasing fat storage, and boosting cancer risks. ",
        "Low-to-moderate alcohol intake disrupts the gut-liver-brain axis, triggering systemic inflammation and compounding health issues. ",
        "Alcohol’s reach extends into our biology, damaging DNA, gut health, and neural circuits while altering hormonal balance and immune function."
      ],
      "connections": [
        "Level up your gut!",
        "Non-food foods",
        "The genetic disconnect",
        "Prevent that cancer",
        "Fermented food benefits",
        "Supplementation is not expensive urine",
        "Hack your fuel",
        "Hangovers",
        "When alcohol hits the cells",
        "Blackouts"
      ],
      "url": "https://wellawarecare.substack.com/p/alcohol-and-dna"
    },
    {
      "id": "Be better than the conventional normal",
      "tldr": [
        "Standard blood test ranges focus on “normal,” but aiming for optimal levels leads to better health outcomes. ",
        "Vitamin D, even if within a “normal” range, often needs to be optimized for bone, muscle, immune, and cognitive health. ",
        "Fasting blood glucose levels, though not classified as diabetic, can still signal risks if they exceed optimal ranges. ",
        "Potassium, hydration, and inflammation markers like albumin offer deeper insights into overall health. ",
        "Assessing sleep quality and environmental factors is essential for both immediate well-being and long-term health."
      ],
      "connections": [
        "Explosive & toxic chemicals in food",
        "Power up with potassium",
        "High performance sleeping",
        "Zinc it up"
      ],
      "url": "https://wellawarecare.substack.com/p/be-better-than-the-conventional-normal"
    },
    {
      "id": "Belly fat!",
      "tldr": [
        "Excess sugar and hormones like cortisol and estrogen mimickers can cause belly fat. Monitoring blood sugar is more effective than calorie counting. ",
        "Avoid diet foods with artificial ingredients; opt for sparkling water, mineral water, or tea. ",
        "Stay active to manage stress and eat plenty of vegetables for gut health. Get enough deep sleep to regulate hormones and prevent weight gain."
      ],
      "connections": [
        "Bread!",
        "One third of your youth",
        "High performance sleeping",
        "Less (eating) is more (healthy)",
        "Damn hard without vitamin D",
        "No sweet dreams with sweets"
      ],
      "url": "https://wellawarecare.substack.com/p/care-13-belly-fat"
    },
    {
      "id": "Blackouts",
      "tldr": [
        "Blackouts occur when memory formation stops, leaving people active but unable to recall events. ",
        "Some drinkers feel sedated, while others remain energized—this latter group is more prone to habitual drinking and blackouts. ",
        "Alcohol alters stress pathways, increasing cortisol and baseline anxiety levels over time. ",
        "Memory blackouts aren’t the same as passing out; they involve functioning without recording memories."
      ],
      "connections": [
        "Brain health 101",
        "When alcohol hits the cells",
        "Alcohol & DNA"
      ],
      "url": "https://wellawarecare.substack.com/p/blackouts"
    },
    {
      "id": "Bonds, alpha females & botox",
      "tldr": [
        "Eye contact, especially right-eye-to-left-eye, is key for emotional bonding. ",
        "Women who spend time together often sync their cycles, influenced by the alpha female. ",
        "Behaviors and attitudes, like divorce or weight gain, can spread through social groups. ",
        "Good health, shown in appearance and energy, often leads to better social and romantic interaction"
      ],
      "connections": [
        "Nasties in beauty"
      ],
      "url": "https://wellawarecare.substack.com/p/care-15-bonds-alpha-females-and-botox"
    },
    {
      "id": "Brain health 101",
      "tldr": [
        "Brain health is foundational to mental health; daily habits like nutrition, sleep, and avoiding toxins are critical. ",
        "Poor lifestyle choices—like neglecting oral health, consuming harmful substances, or not engaging in lifelong learning—can negatively impact brain function. ",
        "Prioritizing Omega-3s, Vitamin D, and regular hormone checks supports optimal brain function and reduces dementia risk. ",
        "Addressing emotional and spiritual well-being through self-reflection, purpose, and relationships enhances overall brain health."
      ],
      "connections": [
        "Effects of mouth's proximity to the brain",
        "Welcome the suck",
        "Non-food foods",
        "High performance sleeping",
        "Power up with potassium",
        "Preventing Alzheimer’s with lifestyle choices",
        "The healthy hungry age better",
        "Zinc it up",
        "Reorder mental disorder",
        "Sweet and salty sugar",
        "Detox with sleep"
      ],
      "url": "https://wellawarecare.substack.com/p/brain-health-101"
    },
    {
      "id": "Brainiac strategies for the brain",
      "tldr": [
        "Poor diet, stress, and lack of sleep shrink the hippocampus, impairing memory and learning. ",
        "Obesity and inactivity harm brain health, while exercise and lean muscle mass protect against aging effects. ",
        "High sugar intake accelerates brain aging, damages memory, and disrupts insulin sensitivity. ",
        "Mindfulness, strength training, and managing chronic conditions promote brain and metabolic health. ",
        "Lifestyle choices, including a healthy diet and regular exercise, significantly impact cognitive vitality and resilience."
      ],
      "connections": [
        "Non-food foods",
        "The sugar consequences of salt",
        "Take 11 minutes a day to postpone death",
        "Sweet and salty sugar",
        "Insulin's hard problem",
        "Hold on to your strength"
      ],
      "url": "https://wellawarecare.substack.com/p/brainiac-strategies-for-the-brain"
    },
    {
      "id": "Bread!",
      "tldr": [
        "Eliminating processed grains for 14 days stabilizes blood sugar and reduces inflammation. ",
        "Healthy grains, like sourdough, enhance mood, digestion, and hunger management. ",
        "Avoiding bad grains repairs the gut lining, decreases joint pain, and improves sleep quality. ",
        "Learn how to distinguish between healthy and unhealthy grains to optimize health benefits."
      ],
      "connections": [
        "The real spice, girl!",
        "Belly fat!",
        "How does fasting affect hormones?",
        "How do you like them apples?",
        "High performance sleeping"
      ],
      "url": "https://wellawarecare.substack.com/p/bread"
    },
    {
      "id": "Can't lose weight?",
      "tldr": [
        "Women’s bodies prioritize safety over weight loss due to evolutionary programming, making stress reduction essential for sustainable health changes. ",
        "Hormones need 24 key nutrients to function. Diet diversity and real food are critical for meeting these requirements. ",
        "Gut and liver health are foundational for hormone metabolism and detoxification, reducing fat storage and improving overall health. ",
        "Menstrual cycles and life stages (perimenopause, menopause) demand tailored nutrition and fasting strategies. ",
        "Toxic exposure disrupts hormonal balance, affecting weight, fertility, and overall health."
      ],
      "connections": [
        "Functional medicine functioning",
        "The real spice, girl!",
        "Belly fat!",
        "Level up your gut!",
        "Fruit juice to fatty liver",
        "Faster weight loss on slow thyroid",
        "Nasties in beauty",
        "Hack your fuel",
        "Pick not Ozempic",
        "When to eat?",
        "Functional medicine functioning"
      ],
      "url": "https://wellawarecare.substack.com/p/cant-lose-weight"
    },
    {
      "id": "Comfy crash",
      "tldr": [
        "The average person consumes 12–13 hours of digital media per day—more screen than sleep. ",
        "Small daily discomforts—like carrying groceries or climbing stairs—are disappearing, and so is resilience. ",
        "Loneliness increases risk of early death by 26%—and the epidemic is growing alongside urban density and noise. ",
        "Modern abundance hijacks ancient survival drives, leading to chronic diseases, addiction, and burnout. ",
        "Fighting back doesn’t require extreme fitness—it starts with tiny daily discomfort wins."
      ],
      "connections": [
        "Crave brain rave",
        "Hack your fuel",
        "Power up with potassium",
        "Preventing Alzheimer’s with lifestyle choices",
        "Socialized wellness"
      ],
      "url": "https://wellawarecare.substack.com/p/comfy-crash"
    },
    {
      "id": "Complexities of depression",
      "tldr": [
        "The chemical imbalance theory oversimplifies depression's causes and treatment. ",
        "Antidepressants have limited efficacy and can carry significant risks, such as suicidal thoughts in younger individuals. ",
        "Depression intertwines with physical health factors like stress, sleep disturbances, and nutrition. ",
        "A holistic approach, including lifestyle changes, offers a more comprehensive way to manage depression. ",
        "Nutritional deficiencies in vitamin D, B12, magnesium, and Omega-3 DHA often contribute to depressive symptoms."
      ],
      "connections": [
        "Brain health 101",
        "Non-food foods",
        "Damn hard without vitamin D",
        "Detox with sleep",
        "Reorder mental disorder",
        "Health we inherit"
      ],
      "url": "https://wellawarecare.substack.com/p/complexities-of-depression"
    },
    {
      "id": "Crave brain rave",
      "tldr": [
        "Cravings are real chemical signals, not mental weakness. They reflect your brain and body seeking balance. ",
        "Triggers include stress, nutrient deficiencies, blood sugar crashes, and social pressure. ",
        "Ultra-processed foods (UPFs) exploit biological mechanisms, creating misleading cravings and disrupting hunger regulation. ",
        "Post-ingestive feedback—how your body “remembers” nutrients—is hijacked by flavor-engineered foods. ",
        "To reduce cravings: restore balance with real food, sufficient protein, deep rest, and stable social cues."
      ],
      "connections": [
        "Your energy source",
        "Non-food foods",
        "Insulin's hard problem",
        "Reorder mental disorder",
        "Starve that cancer",
        "Sweet and salty sugar",
        "Explosive & toxic chemicals in food",
        "Preventing Alzheimer’s with lifestyle choices"
      ],
      "url": "https://wellawarecare.substack.com/p/crave-brain-rave"
    },
    {
      "id": "Crystal clear pain",
      "tldr": [
        "Oxalates are naturally occurring compounds found in many plant foods. In small amounts, the body can handle them. But when intake, absorption, or clearance is mismatched, oxalates bind minerals, form crystals, and interfere with cellular energy systems. Over time, this load shows up far beyond the kidneys—affecting pain, circulation, tissue repair, and mitochondrial function."
      ],
      "connections": [
        "Forged in iron",
        "Joint pain",
        "How does fasting affect hormones?",
        "Level up your gut!"
      ],
      "url": "https://wellawarecare.substack.com/p/crystal-clear-pain"
    },
    {
      "id": "Damn hard without vitamin D",
      "tldr": [
        "Vitamin D is vital for immunity, mood regulation, skin health, and cardiovascular function—not just bones. ",
        "Deficiency can lead to asthma, eczema, depression, irregular cycles, and erectile dysfunction. ",
        "Pair vitamin D with vitamin K2 to prevent calcium buildup and enhance bone and heart health. ",
        "Autoimmune and inflammatory conditions benefit from higher vitamin D doses alongside keto or intermittent fasting. ",
        "Vitamin D may be the missing link for those struggling with chronic fatigue or respiratory issues."
      ],
      "connections": [
        "Be better than the conventional normal",
        "Functional medicine functioning",
        "Explosive & toxic chemicals in food",
        "Vitamin D Deficiency",
        "Hold on to your strength"
      ],
      "url": "https://wellawarecare.substack.com/p/damn-hard-without-vitamin-d"
    },
    {
      "id": "Detox with sleep",
      "tldr": [
        "Quality sleep clears toxins, boosts immunity, balances hormones, and strengthens memory. ",
        "Your chronotype (morning, evening, or intermediate) influences sleep patterns; aligning with it can optimize productivity. ",
        "Naps improve performance, cardiovascular health, and emotional well-being when timed correctly. ",
        "Regular sleep reduces the risk of Alzheimer’s, obesity, and diabetes while enhancing resilience and mental clarity."
      ],
      "connections": [
        "Be better than the conventional normal",
        "High performance sleeping",
        "Preventing Alzheimer’s with lifestyle choices",
        "Brain health 101"
      ],
      "url": "https://wellawarecare.substack.com/p/detox-with-sleep"
    },
    {
      "id": "Don't de-health while deodorizing",
      "tldr": [
        "Conventional deodorants, especially antiperspirants with aluminum salts, pose health risks by blocking sweat ducts and increasing toxic absorption. ",
        "Aluminum salts in antiperspirants are linked to higher breast cancer risk, particularly when used before age 30. ",
        "Aerosol deodorants carry additional inhalation risks, and petroleum byproducts in some deodorants can contain carcinogenic compounds. ",
        "Natural alternatives like coconut oil, baking soda, and essential oils provide safer options. ",
        "An armpit detox with clay can help remove residual aluminum salts and reset natural body odor."
      ],
      "connections": [
        "Femme fatale fragrance",
        "Ketogenic diet and cancer",
        "How does fasting affect hormones?",
        "Nasties in beauty",
        "The genetic disconnect",
        "Starve that cancer"
      ],
      "url": "https://wellawarecare.substack.com/p/dont-de-health-while-deodorizing"
    },
    {
      "id": "Eating electronics",
      "tldr": [
        "Environmental toxins like BPA and phthalates act as biological mimics that disrupt hormonal signaling. Found in common items like thermal receipts and plastic food containers, these chemicals dock into hormone receptors and trick the body into downregulating natural production. Managing this load requires identifying the mechanical intersection of heat and plastic to prevent systemic chemical leaching."
      ],
      "connections": [
        "Nasties in beauty",
        "The genetic disconnect",
        "How does fasting affect hormones?",
        "Is organic food worth it?"
      ],
      "url": "https://wellawarecare.substack.com/p/eating-electronics"
    },
    {
      "id": "Effects of mouth's proximity to the brain",
      "tldr": [
        "Oral bacteria, like P. gingivalis, can cross the blood-brain barrier and are linked to Alzheimer’s. ",
        "Mouth breathing, poor diet, and inadequate oral hygiene practices rank as top causes of gum disease. ",
        "Flossing, tongue scraping, and gum massage play crucial roles in maintaining oral health and preventing systemic diseases. ",
        "Certain mouthwashes can harm the oral microbiome; gentle brushing and eco-friendly tools are recommended."
      ],
      "connections": [
        "Non-food foods",
        "Preventing Alzheimer’s with lifestyle choices",
        "Brain health 101",
        "Less (eating) is more (healthy)",
        "Nasties in beauty",
        "Hold on to your strength",
        "Detox with sleep"
      ],
      "url": "https://wellawarecare.substack.com/p/effects-of-mouths-proximity-to-the"
    },
    {
      "id": "Explosive & toxic chemicals in food",
      "tldr": [
        "High deuterium in processed foods accelerates aging; low-deuterium diets are healthier. ",
        "Glyphosate disrupts liver function and microbiomes, and harms wildlife. ",
        "Don't take calcium with vitamin D to avoid calcium buildup. Vitamin K2 helps direct calcium to bones. ",
        "Sunlight boosts melatonin and skin protection. Deuterium, glyphosate, and vitamin D deficiency affect telomere health."
      ],
      "connections": [
        "Bread!",
        "Is organic food worth it?",
        "Level up your gut!",
        "Femme fatale fragrance",
        "Functional medicine functioning",
        "Your energy source",
        "Damn hard without vitamin D"
      ],
      "url": "https://wellawarecare.substack.com/p/care-14-explosive-and-toxic-chemicals"
    },
    {
      "id": "Faster weight loss on slow thyroid",
      "tldr": [
        "Fasting, especially intermittent fasting and OMAD (One Meal A Day), boosts metabolism, enhances cognitive function, and promotes gut health through autophagy. ",
        "People with slow thyroid or thyroid removal can benefit from transitioning fuel sources from glucose to ketones, aiding in weight loss and improving metabolic efficiency. ",
        "Prebiotic fiber and fasting hacks ease hunger, promote satiety, and support gut health during fasting. ",
        "A gradual progression from three meals a day to OMAD helps stabilize insulin levels and supports fat burning, especially in those with thyroid issues."
      ],
      "connections": [
        "How does fasting affect hormones?",
        "Functional medicine functioning",
        "How do you like them apples?",
        "Level up your gut!",
        "Less (eating) is more (healthy)"
      ],
      "url": "https://wellawarecare.substack.com/p/faster-weight-loss-on-slow-thyroid"
    },
    {
      "id": "Femme fatale fragrance",
      "tldr": [
        "Phthalates, used as fragrance fixatives in many feminine care products, are estrogenic compounds that disrupt hormonal balance and pose serious health risks. ",
        "Feminine care products like scented tampons, pads, and period underwear can deliver harmful chemicals directly to sensitive areas, bypassing the body’s natural detox pathways. ",
        "Organic cotton pads, medical-grade silicone menstrual cups, and PFAS-tested period underwear offer safer alternatives. ",
        "The highly absorptive nature of the vaginal area makes it critical to avoid products containing harmful chemicals, including plasticizers and PFAS."
      ],
      "connections": [
        "Don't de-health while deodorizing",
        "Nasties in beauty",
        "The genetic disconnect",
        "Master of detox"
      ],
      "url": "https://wellawarecare.substack.com/p/femme-fatale-fragrance"
    },
    {
      "id": "Fermented food benefits",
      "tldr": [
        "A diverse gut microbiome supports immunity, hormone balance, and mental health. ",
        "Fermented foods like sauerkraut, kefir, and Greek yogurt improve microbial diversity and reduce inflammation. ",
        "Fiber’s effects on gut health vary, but low-sugar fermented foods offer consistent benefits. ",
        "Supplements with probiotics, prebiotics, and digestive enzymes are essential for those lacking dietary support. ",
        "Moderation is crucial—excessive supplement use can cause issues like brain fog."
      ],
      "connections": [
        "The real spice, girl!",
        "Level up your gut!",
        "Explosive & toxic chemicals in food",
        "How do you like them apples?",
        "Non-food foods",
        "Supplementation is not expensive urine",
        "Hack your fuel"
      ],
      "url": "https://wellawarecare.substack.com/p/fermented-food-benefits"
    },
    {
      "id": "Filter with liver",
      "tldr": [
        "The liver is designed to absorb stress quietly. It stores fat, neutralizes toxins, processes hormones, manages bile, filters microbial byproducts, and regenerates without complaint. Because of this resilience, dysfunction rarely appears as pain or obvious disease. Instead, it emerges indirectly—through metabolic markers, hormonal shifts, gut symptoms, brain changes, and sensitivity to substances that once caused no issue. Seeing liver health requires tracing how these systems stay connected."
      ],
      "connections": [
        "Can't lose weight?",
        "When alcohol hits the cells",
        "Level up your gut!",
        "Inside job",
        "Rot is in the air",
        "Fruit juice to fatty liver",
        "One third of your youth",
        "The sugar consequences of salt",
        "When to eat?"
      ],
      "url": "https://wellawarecare.substack.com/p/filter-with-liver"
    },
    {
      "id": "Focus stacking",
      "tldr": [
        "Most people use caffeine as a blunt instrument to override fatigue, often resulting in \"scattered brain\" and energy crashes. The synergy between caffeine and L-Theanine—a molecule used by monks for centuries—represents a shift from raw stimulation to controlled attention. By regulating the nervous system's electrical baseline, this stack allows for high-output work without the physiological tax of a \"fight or flight\" response."
      ],
      "connections": [
        "Filter with liver",
        "Level up your gut!",
        "Super sea food",
        "No sweet dreams with sweets"
      ],
      "url": "https://wellawarecare.substack.com/p/focus-stacking"
    },
    {
      "id": "Forged in iron",
      "tldr": [
        "Mineral balance is key to longevity—deficiencies or overloads disrupt enzymatic function, protein folding, and overall health. ",
        "Iron is a double-edged sword—critical for survival but dangerous in excess, leading to oxidative stress, inflammation, and chronic disease. ",
        "Zinc and copper must be balanced—too much zinc can deplete copper, leading to iron mismanagement and metabolic dysfunction. ",
        "Ferritin levels correlate with longevity—high levels accelerate aging, while moderate levels promote optimal health. ",
        "Vitamin A plays a role in iron and copper transport, making bioavailable animal-based sources crucial for absorption."
      ],
      "connections": [
        "Zinc it up"
      ],
      "url": "https://wellawarecare.substack.com/p/forged-in-iron"
    },
    {
      "id": "Fruit juice to fatty liver",
      "tldr": [
        "Fruit juice, despite being perceived as healthy, can cause fatty liver due to its high fructose content. ",
        "Fructose is metabolized by the liver and can lead to metabolic syndrome, obesity, and non-alcoholic fatty liver disease (NAFLD). ",
        "The lack of fiber in fruit juice accelerates fructose absorption, increasing health risks even without weight gain. ",
        "Smoothies with fruit juices can spike blood sugar levels, sometimes higher than sodas."
      ],
      "connections": [
        "The sugar consequences of salt",
        "One third of your youth",
        "Is organic food worth it?",
        "Less (eating) is more (healthy)",
        "When to eat?",
        "Starve that cancer",
        "Insulin's hard problem",
        "Can't lose weight?"
      ],
      "url": "https://wellawarecare.substack.com/p/care-16-fruit-juice-to-fatty-liver"
    },
    {
      "id": "Full of full fat",
      "tldr": [
        "Visceral fat is not just stored energy; it is an active, inflammatory organ. Unlike subcutaneous fat (the kind you can pinch), visceral fat wraps around internal organs and secretes cytokines that trigger systemic inflammation. This creates a biological feedback loop where chronic inflammation impairs insulin signaling, leading to more fat storage and a higher baseline of systemic stress."
      ],
      "connections": [
        "Alcohol & DNA",
        "Belly fat!",
        "Can't lose weight?",
        "Faster weight loss on slow thyroid",
        "Filter with liver",
        "Hack your fuel",
        "How do you like them apples?",
        "Is organic food worth it?",
        "The sugar consequences of salt",
        "When to eat?"
      ],
      "url": "https://wellawarecare.substack.com/p/full-of-full-fat"
    },
    {
      "id": "Functional medicine functioning",
      "tldr": [
        "Autoimmune diseases are linked to immune dysfunction, inflammation, gut issues, and stress. ",
        "Functional medicine treats root causes, considering allergens, microbes, toxins, stress, and diet. ",
        "To reverse autoimmune diseases: eliminate mold, eat whole foods, test for infections, address gluten sensitivity, and heal the gut. ",
        "Vitamin D is essential for managing autoimmune conditions, hormone balance in women, and testosterone and bone health in men."
      ],
      "connections": [
        "Your energy source"
      ],
      "url": "https://wellawarecare.substack.com/p/care-11-functional-medicine-functioning"
    },
    {
      "id": "Get muscle mass.ive",
      "tldr": [
        "Muscle isn’t a passive calorie-burner at rest—its real power is in glucose control, fat burning, and hormonal signaling. ",
        "True muscle health = strong function, mitochondrial density, low fat infiltration—not just size. ",
        "Peak muscle mass in your 20s–30s sets the foundation for resilience and independence later. ",
        "Sarcopenia (age-related muscle loss) predicts frailty, cognitive decline, and early death. ",
        "Resistance training + protein-rich meals are your best investments for metabolic health, brain health, and long life."
      ],
      "connections": [
        "Meat (head) and iron (maiden)",
        "Hack your fuel",
        "Hold on to your strength",
        "Stress on purpose",
        "Be better than the conventional normal",
        "Power up with potassium",
        "Your energy source"
      ],
      "url": "https://wellawarecare.substack.com/p/get-muscle-mass.ive"
    },
    {
      "id": "Grit, Glucose & Grind",
      "tldr": [
        "Tenacity and willpower are not fixed traits — they are physiological capacities that can be strengthened. ",
        "The anterior mid-cingulate cortex (aMCC) serves as the central hub of persistence and goal-directed action. ",
        "Willpower is shaped more by belief systems and neural engagement than by glucose availability. ",
        "The autonomic nervous system provides the energetic foundation for sustained effort. ",
        "Purposeful discomfort, repetitive action, and open-ended practices enhance willpower over time."
      ],
      "connections": [
        "Hack your fuel",
        "Detox with sleep",
        "Get muscle mass.ive",
        "Stress on purpose"
      ],
      "url": "https://wellawarecare.substack.com/p/grit-glucose-and-grind"
    },
    {
      "id": "Hack your fuel",
      "tldr": [
        "Leptin is your fat-burning hormone, but resistance to it blocks weight loss. Fasting, metabolic switching, and protein cycling restore leptin sensitivity. ",
        "BDNF, a brain-enhancing protein, suppresses appetite, regulates blood sugar, and improves cognitive health. ",
        "Bone broth aids fasting by healing the gut, reducing hunger, and supporting metabolism with glycine, collagen, and electrolytes. ",
        "Protein cycling paired with fasting maximizes fat-burning and metabolic flexibility. ",
        "17-hour fasts with strategic nutrition stimulate autophagy, muscle growth, and insulin sensitivity for optimal weight loss."
      ],
      "connections": [
        "Your energy source",
        "Power up with potassium",
        "The healthy hungry age better",
        "Less (eating) is more (healthy)",
        "Stress on purpose",
        "When to eat?"
      ],
      "url": "https://wellawarecare.substack.com/p/hack-your-fuel"
    },
    {
      "id": "Hangovers",
      "tldr": [
        "Hangovers disrupt your brain, gut, and body, causing headaches, nausea, fatigue, and anxiety. ",
        "Alcohol interrupts sleep quality, microbiota balance, and electrolytes, worsening next-day symptoms. ",
        "Congeners in drinks like red wine and brandy intensify hangovers by impacting the gut microbiome. ",
        "Hydration, gut support, and electrolyte replenishment help mitigate hangovers, but the best prevention is moderation. ",
        "Cold exposure may alleviate symptoms but should be used cautiously."
      ],
      "connections": [
        "Power up with potassium",
        "Level up your gut!",
        "Supplementation is not expensive urine",
        "Alcohol & DNA",
        "Hack your fuel",
        "Fermented food benefits",
        "Inflammation to cancer",
        "When alcohol hits the cells",
        "Blackouts"
      ],
      "url": "https://wellawarecare.substack.com/p/hangovers"
    },
    {
      "id": "Health we inherit",
      "tldr": [
        "Trauma influences not just your mental health but your biology, increasing risks for chronic diseases like heart disease, cancer, and diabetes. ",
        "Tools like the ACE questionnaire link adverse childhood experiences to long-term health outcomes. ",
        "Your exposome—the sum of everything you've been exposed to—shapes your health more than your genes. ",
        "Epigenetics shows that trauma and environmental factors can reprogram your genes, affecting not just you but future generations. ",
        "Psychedelics, lifestyle changes, and epigenetic research offer groundbreaking approaches to healing trauma and reversing its effects."
      ],
      "connections": [
        "Your energy source",
        "Explosive & toxic chemicals in food",
        "The genetic disconnect",
        "Reorder mental disorder",
        "Brainiac strategies for the brain"
      ],
      "url": "https://wellawarecare.substack.com/p/health-we-inherit"
    },
    {
      "id": "High performance sleeping",
      "tldr": [
        "Sleep consistency is more crucial than total sleep duration for optimal health and performance. ",
        "Sleep timing and aligning with your circadian rhythm are key factors for maximizing brain and body performance. ",
        "Improved sleep can reduce cortisol, improve athletic performance, and enhance cognitive abilities. ",
        "Small sleep improvements, like adding 30 extra minutes, significantly boost immune function, reduce body fat, and improve recovery. ",
        "High-intensity exercise late in the evening can interfere with sleep quality, so switching to restorative exercises at night is recommended."
      ],
      "connections": [
        "Be better than the conventional normal",
        "How does fasting affect hormones?",
        "One third of your youth",
        "Detox with sleep",
        "Hold on to your strength",
        "No sweet dreams with sweets",
        "Zinc it up",
        "Brainiac strategies for the brain"
      ],
      "url": "https://wellawarecare.substack.com/p/high-performance-sleeping"
    },
    {
      "id": "Hold on to your strength",
      "tldr": [
        "Grip strength is a vital health marker, predicting risks like Alzheimer’s and dementia. ",
        "Potassium is essential for muscle function, hydration, and heart health. ",
        "Vitamin D and balanced blood glucose levels prevent muscle fatigue and oxidative stress. ",
        "Creatine boosts muscle, bone, and brain health, enhancing strength and cognition. ",
        "Regular exercise and proper nutrition are keys to maintaining long-term health."
      ],
      "connections": [
        "Power up with potassium",
        "Take 11 minutes a day to postpone death",
        "Be better than the conventional normal",
        "Damn hard without vitamin D"
      ],
      "url": "https://wellawarecare.substack.com/p/hold-on-to-your-strength"
    },
    {
      "id": "How do you like them apples?",
      "tldr": [
        "Apple cider vinegar stabilizes blood sugar, managing glycation and supporting oxygen delivery, key factors for slowing aging. ",
        "As a prebiotic, it enhances gut health, serotonin production, and mood, benefiting brain health and neuroplasticity. ",
        "It supports fat burning and metabolic health, making it a valuable addition to a longevity-focused lifestyle. ",
        "Lowering Hemoglobin A1C levels with apple cider vinegar can reduce diabetes risk and improve overall well-being. ",
        "Incorporating apple cider vinegar aids in transitioning into a fasted state and amplifies the anti-aging effects of fasting."
      ],
      "connections": [
        "Functional medicine functioning",
        "Level up your gut!",
        "Belly fat!",
        "The healthy hungry age better",
        "Hack your fuel"
      ],
      "url": "https://wellawarecare.substack.com/p/how-do-you-like-them-apples"
    },
    {
      "id": "How does fasting affect hormones?",
      "tldr": [
        "Fasting boosts serotonin for better mood and sleep, increases growth hormone for anti-aging, and raises glucagon for fat burning. ",
        "Fasting can regulate blood sugar through adrenaline and cortisol, and help reverse leptin resistance. ",
        "Lack of sleep increases hunger hormones; glycine can improve insulin sensitivity and reduce kidney stone risk."
      ],
      "connections": [
        "The healthy hungry age better",
        "High performance sleeping",
        "Faster weight loss on slow thyroid",
        "Zinc it up",
        "Less (eating) is more (healthy)",
        "Insulin's hard problem",
        "Hack your fuel",
        "Detox with sleep"
      ],
      "url": "https://wellawarecare.substack.com/p/how-does-fasting-affect-hormones"
    },
    {
      "id": "Inflammation to cancer",
      "tldr": [
        "The immune system is vital in eliminating abnormal cells, including cancer. ",
        "Many cancers are influenced by environmental factors and lifestyle choices, not just genetics. ",
        "Chronic inflammation from modern stressors significantly increases cancer risk and other chronic diseases. ",
        "Reducing inflammation supports immune health and improves overall well-being. ",
        "Fourteen of the top fifteen leading causes of death are linked to chronic inflammation."
      ],
      "connections": [
        "Your energy source",
        "Ketogenic diet and cancer",
        "Non-food foods",
        "Prevent that cancer",
        "Starve that cancer",
        "The genetic disconnect"
      ],
      "url": "https://wellawarecare.substack.com/p/inflammation-to-cancer"
    },
    {
      "id": "Input equals IQ",
      "tldr": [
        "IQ is dynamic—stress, toxins, habits, and belief systems can raise or lower it daily. ",
        "Cognitive performance thrives on novelty, nutrient density, and neural efficiency. ",
        "Intelligence is not fixed; genius is trained, not inherited. ",
        "Behavior, food, light, and peers act as brain upgrades or downgrades. ",
        "The brain’s ability to grow (via BDNF and neuroplasticity) is responsive to friction, fasting, emotion, and movement."
      ],
      "connections": [
        "Forged in iron",
        "Hack your fuel",
        "Brain health 101",
        "Brainiac strategies for the brain",
        "Detox with sleep",
        "Preventing Alzheimer’s with lifestyle choices"
      ],
      "url": "https://wellawarecare.substack.com/p/input-equals-iq"
    },
    {
      "id": "Inside job",
      "tldr": [
        "Your gut has more say in your mood, cravings, and clarity than you do. It runs on bacteria, not willpower. When it’s balanced, you feel grounded and sharp. When it’s off, everything from anxiety to appetite follows. Modern life—processed food, stress, antibiotics, alcohol, and chemical residues—reshapes this ecosystem daily. The real question isn’t how your gut feels, but who’s in charge of it: you or what you’ve been feeding it."
      ],
      "connections": [
        "Fermented food benefits",
        "How do you like them apples?",
        "Level up your gut!",
        "Non-food foods"
      ],
      "url": "https://wellawarecare.substack.com/p/inside-job"
    },
    {
      "id": "Insulin's hard problem",
      "tldr": [
        "Insulin resistance happens when cell membranes stiffen, blocking nutrients and hormones. ",
        "Healthy fats, toxin reduction, and a positive mindset are key to reversing resistance. ",
        "Mitochondria thrive with fasting, organ meats, and red light exposure, boosting energy and detox. ",
        "Hormonal balance, particularly cortisol and oxytocin, improves insulin sensitivity. ",
        "Avoid frequent eating to prevent constant insulin spikes and support nutrient absorption."
      ],
      "connections": [
        "How does fasting affect hormones?",
        "One third of your youth",
        "The sugar consequences of salt",
        "Faster weight loss on slow thyroid",
        "Less (eating) is more (healthy)",
        "Hack your fuel",
        "Stress on purpose"
      ],
      "url": "https://wellawarecare.substack.com/p/insulins-hard-problem"
    },
    {
      "id": "Is organic food worth it?",
      "tldr": [
        "Organic food is better for preventing chronic diseases, but non-organic is okay if it has fewer pesticides and your health is good. ",
        "Pesticides can disrupt hormones, leading to issues like belly fat. ",
        "Glyphosate, a common pesticide, harms gut health and reduces biodiversity."
      ],
      "connections": [
        "Explosive & toxic chemicals in food",
        "Level up your gut!",
        "Functional medicine functioning",
        "Your energy source",
        "Non-food foods"
      ],
      "url": "https://wellawarecare.substack.com/p/care-12-is-organic-food-worth-it"
    },
    {
      "id": "Joint pain",
      "tldr": [
        "Joint pain is not an inevitable part of aging — it’s a sign of metabolic, inflammatory, or gut dysfunction. ",
        "Your joints can become insulin resistant, just like your brain. ",
        "Leaky gut lets toxins like LPS reach the joints and trigger chronic inflammation. ",
        "Glycation from high blood sugar damages cartilage and increases creaking, pain, and stiffness. ",
        "Support joint health through anti-inflammatory foods, targeted compounds like L-carnitine and Boswellia, and prioritizing sleep and mobility."
      ],
      "connections": [
        "Insulin's hard problem",
        "Detox with sleep",
        "Hack your fuel",
        "Level up your gut!",
        "How do you like them apples?",
        "Comfy crash",
        "The real spice, girl!"
      ],
      "url": "https://wellawarecare.substack.com/p/joint-pain"
    },
    {
      "id": "Ketogenic diet and cancer",
      "tldr": [
        "The ketogenic diet starves cancer cells by limiting glucose, their primary fuel source, potentially slowing tumor growth. ",
        "Ketosis can reduce inflammation, enhance recovery, and potentially work synergistically with conventional treatments like chemotherapy. ",
        "Addressing mitochondrial health and the body’s signaling systems is crucial in understanding cancer’s complexities and potential treatment strategies. ",
        "Embracing a holistic approach, including diet, sleep, and emotional well-being, may offer new hope in cancer care."
      ],
      "connections": [
        "Functional medicine functioning",
        "The real spice, girl!",
        "Preventing Alzheimer’s with lifestyle choices",
        "Take 11 minutes a day to postpone death",
        "The healthy hungry age better",
        "Your energy source",
        "Starve that cancer",
        "Prevent that cancer",
        "Inflammation to cancer",
        "Detox with sleep"
      ],
      "url": "https://wellawarecare.substack.com/p/ketogenic-diet-and-cancer"
    },
    {
      "id": "Lactose in-tolerance?",
      "tldr": [
        "Around 65% of the global population is lactose intolerant, and the prevalence increases with age. ",
        "Lactose intolerance symptoms occur when the body cannot properly digest dairy’s carbohydrate content due to low levels of lactase. ",
        "Gut health and skin conditions are closely linked, making dairy intolerance a potential trigger for skin issues like acne and eczema. ",
        "Dairy alternatives and lactase enzymes can offer solutions, but eliminating dairy often improves gut health. ",
        "Non-dairy sources of calcium, such as almonds, sardines, and leafy greens, provide nutrient-rich alternatives to dairy."
      ],
      "connections": [
        "Level up your gut!",
        "Explosive & toxic chemicals in food",
        "Vitamin D Deficiency",
        "Damn hard without vitamin D"
      ],
      "url": "https://wellawarecare.substack.com/p/lactose-in-tolerance"
    },
    {
      "id": "Lean mean double green",
      "tldr": [
        "Spirulina and chlorella are among the most nutrient-dense foods, with spirulina excelling in energy production and chlorella in detoxification. ",
        "Spirulina contains superoxide dismutase (SOD), an antioxidant critical for mitochondrial function and cellular protection, but its production declines after age 30. ",
        "Chlorella binds to heavy metals, pesticides, and alcohol byproducts, assisting in detoxification and reducing oxidative stress. ",
        "Phycocyanin, a unique compound in spirulina, enhances energy production in healthy cells but triggers cell death in cancerous or senescent cells. ",
        "The quality of spirulina and chlorella matters—contaminated sources may contain harmful toxins."
      ],
      "connections": [
        "Your energy source",
        "Non-food foods",
        "Master of detox",
        "One third of your youth"
      ],
      "url": "https://wellawarecare.substack.com/p/lean-mean-double-green"
    },
    {
      "id": "Less (eating) is more (healthy)",
      "tldr": [
        "Fasting progresses through six stages, from blood sugar stabilization to immune regeneration, offering diverse health benefits. ",
        "Drinks like water, tea, and coffee support fasting, but additives like sugar or alcohol disrupt its effects. ",
        "Prolonged fasting activates autophagy and stem cell regeneration, enhancing cellular cleanup and immune health. ",
        "Explore fasting’s physiological changes, from fat burning to immune renewal."
      ],
      "connections": [
        "Faster weight loss on slow thyroid",
        "The healthy hungry age better",
        "Your energy source",
        "Belly fat!",
        "How does fasting affect hormones?",
        "Level up your gut!",
        "Prevent that cancer",
        "Starve that cancer"
      ],
      "url": "https://wellawarecare.substack.com/p/less-eating-is-more-healthy"
    },
    {
      "id": "Level up your gut!",
      "tldr": [
        "Eat a variety of fiber-rich and fermented foods for a diverse gut microbiome. ",
        "Avoid sugar, alcohol, antibiotics, GMO foods, and artificial sweeteners to maintain gut diversity. ",
        "Intermittent fasting and coffee (without sugar/milk) support gut health and overall well-being. ",
        "A healthy microbiome aids immune function, hormone regulation, and mood."
      ],
      "connections": [
        "Explosive & toxic chemicals in food",
        "Level up your gut!",
        "Bread!",
        "Is organic food worth it?",
        "Non-food foods",
        "Lactose in-tolerance?",
        "Fermented food benefits",
        "Supplementation is not expensive urine"
      ],
      "url": "https://wellawarecare.substack.com/p/level-up-your-gut"
    },
    {
      "id": "Life lemon duo",
      "tldr": [
        "We all carry moments our minds can’t name. When something overwhelms us before we can explain it, the body takes the record. Muscles tighten, breath shortens, heart rhythm shifts—and long after the event fades, the body still prepares for danger. Trauma isn’t just what happened; it’s what stays when we had no way to fight, flee, or speak."
      ],
      "connections": [
        "Mind at volume",
        "Health we inherit",
        "Reorder mental disorder",
        "Right brain is right",
        "Complexities of depression"
      ],
      "url": "https://wellawarecare.substack.com/p/life-lemon-duo"
    },
    {
      "id": "Master of detox",
      "tldr": [
        "Glutathione is crucial for detoxifying the body and combating oxidative stress. ",
        "Traditional methods like IV or oral supplements have absorption challenges, but topical applications offer better delivery. ",
        "Glutathione enhances anti-aging, detoxification, and skin health when applied topically. ",
        "It helps balance hormones by removing endocrine-disrupting toxins from the body. ",
        "Supporting glutathione levels boosts mitochondrial health, energy, and cellular repair."
      ],
      "connections": [
        "Supplements for your pretty face",
        "Femme fatale fragrance",
        "Don't de-health while deodorizing",
        "Nasties in beauty",
        "The genetic disconnect",
        "Zinc it up"
      ],
      "url": "https://wellawarecare.substack.com/p/master-of-detox"
    },
    {
      "id": "Meat (head) and iron (maiden)",
      "tldr": [
        "Protein is the only macronutrient required in large amounts, while carbohydrates are non-essential. ",
        "DNA’s primary function is protein synthesis, assembling amino acids into structures like muscles, bones, and immune cells. ",
        "Muscle loss is a major driver of aging, increasing inflammation, insulin resistance, and hormonal dysfunction. ",
        "Protein digestion efficiency depends on stomach acid (HCL) and digestive enzymes—poor digestion leads to nutrient deficiencies and metabolic dysfunction. ",
        "Heme iron from animal protein is the most absorbable form, while plant-based iron is poorly absorbed and often bound to anti-nutrients."
      ],
      "connections": [
        "Hack your fuel",
        "Is organic food worth it?",
        "Lactose in-tolerance?",
        "Pick not Ozempic"
      ],
      "url": "https://wellawarecare.substack.com/p/meat-head-and-iron-maiden"
    },
    {
      "id": "Mind at volume",
      "tldr": [
        "Your inner voice is your mind’s narrator—the one rehearsing, remembering, warning, and planning. It’s essential for self-control, motivation, and focus. But when the voice turns up too loud, thought becomes noise. The same mechanism that lets us reflect can trap us in loops of rumination, regret, and worry. Understanding when the inner voice helps—and when it harms—is how we turn chatter back into clarity."
      ],
      "connections": [
        "Life lemon duo",
        "Brain health 101"
      ],
      "url": "https://wellawarecare.substack.com/p/mind-at-volume"
    },
    {
      "id": "Nasties in beauty",
      "tldr": [
        "Silicone breast implants can leach harmful substances like platinum, causing inflammation and health risks. ",
        "Makeup removers and beauty products often include chemicals that increase toxin absorption through the skin. ",
        "Phthalates in fragrances disrupt hormones, reducing testosterone and affecting fertility. ",
        "BPA in plastics and beauty packaging promotes weight gain and metabolic issues. ",
        "A minimalist, natural approach to skincare reduces toxic exposure, supports hormone balance, and improves detox pathways."
      ],
      "connections": [
        "Femme fatale fragrance",
        "Bonds, alpha females & botox",
        "The real spice, girl!",
        "The genetic disconnect"
      ],
      "url": "https://wellawarecare.substack.com/p/nasties-in-beauty"
    },
    {
      "id": "No sweet dreams with sweets",
      "tldr": [
        "Poor sleep increases cravings for sugary foods and disrupts metabolism. ",
        "Lemon juice, lime juice, and cinnamon can naturally regulate blood sugar spikes. ",
        "Berberine is a potent natural glucose regulator comparable to metformin. ",
        "Excess sugar worsens ADHD symptoms, while omega-3s can improve focus and mood. ",
        "Prioritizing sleep and a balanced diet supports sugar metabolism and reduces cravings."
      ],
      "connections": [
        "High performance sleeping",
        "Non-food foods",
        "The sugar consequences of salt",
        "Detox with sleep",
        "Sweet and salty sugar"
      ],
      "url": "https://wellawarecare.substack.com/p/no-sweet-dreams-with-sweets"
    },
    {
      "id": "Non-food foods",
      "tldr": [
        "Excessive sugar intake and ultra-processed foods are linked to metabolic disorders, cognitive decline, and mental health issues. ",
        "Aspartame and non-nutritive sweeteners may impact cognitive health by disrupting neurotransmitters and gut microbiome balance. ",
        "Even moderate alcohol consumption affects brain structure and function, increasing cancer risks and psychological dependence. ",
        "Seed oils high in omega-6 fatty acids contribute to inflammation, oxidative stress, and mitochondrial damage, potentially due to misleading health recommendations."
      ],
      "connections": [
        "The sugar consequences of salt",
        "Explosive & toxic chemicals in food",
        "Is organic food worth it?",
        "Level up your gut!",
        "Brain health 101",
        "Your energy source",
        "Power up with potassium",
        "Prevent that cancer",
        "Starve that cancer"
      ],
      "url": "https://wellawarecare.substack.com/p/non-food-foods"
    },
    {
      "id": "One third of your youth",
      "tldr": [
        "Glycine, vital for collagen production, is often deficient in modern diets, leading to various health issues. ",
        "It supports antioxidant production, liver detoxification, and gut health, helping to prevent autoimmune diseases. ",
        "Glycine enhances sleep, insulin sensitivity, and blood sugar regulation, making it valuable for managing conditions like gout and fatty liver. ",
        "It can also prevent kidney stones and improve overall metabolic health by balancing insulin and glucagon. ",
        "Simple dietary changes, such as consuming gelatin or bone broth, can boost glycine intake."
      ],
      "connections": [
        "Your energy source",
        "Supplements for your pretty face",
        "Level up your gut!",
        "High performance sleeping",
        "Fermented food benefits",
        "The genetic disconnect",
        "Hack your fuel",
        "Master of detox",
        "Detox with sleep"
      ],
      "url": "https://wellawarecare.substack.com/p/one-third-of-your-youth"
    },
    {
      "id": "Out of focus",
      "tldr": [
        "Vision isn’t just about seeing clearly—it’s about how the brain, light, and metabolism talk to each other. The loss of near focus we call _presbyopia_ isn’t simply age; it’s often a slow adaptation to how we live and light ourselves. From screen strain to sunlight deficit, our eyes mirror our daily habits. The same systems that help us focus visually also anchor our attention, mood, and energy. When vision fades, it may be signaling that the rest of the body—and mind—has drifted out of focus too."
      ],
      "connections": [
        "Damn hard without vitamin D",
        "Inside job"
      ],
      "url": "https://wellawarecare.substack.com/p/out-of-focus"
    },
    {
      "id": "Peaked at 25",
      "tldr": [
        "Peak span is the duration of life spent within 90% of peak physical and cognitive function. Essential biological markers—including muscle mass and bone density—typically peak at age 25 before entering a steady physiological decline. Sustaining this peak requires active intervention to prevent the natural shedding of structural tissue and the erosion of cognitive reserves."
      ],
      "connections": [
        "Working workout",
        "Get muscle mass.ive",
        "Power powder",
        "Be better than the conventional normal",
        "Hack your fuel",
        "Stress on purpose"
      ],
      "url": "https://wellawarecare.substack.com/p/peaked-at-25"
    },
    {
      "id": "Pick not Ozempic",
      "tldr": [
        "Willpower is no match for your evolutionary instincts, which prioritize survival over food control. ",
        "Stress, sleep deprivation, and ultra-processed foods worsen cravings and disrupt appetite hormones. ",
        "Drugs like Ozempic can help with weight loss but don’t address behavioral changes or root causes. ",
        "Muscle loss, slower metabolism, and severe side effects are significant downsides of long-term Ozempic use. ",
        "“If you're a severely obese person, you have severe health conditions, you're really struggling to get going, can it be a helpful aid? Absolutely. Should it be given to everybody who wants to look good for a party or a wedding? Absolutely not.”"
      ],
      "connections": [
        "Your energy source",
        "Hold on to your strength"
      ],
      "url": "https://wellawarecare.substack.com/p/pick-not-ozempic"
    },
    {
      "id": "Power powder",
      "tldr": [
        "Visible fatigue is often the final stage of a deeper systemic drain. Research suggests that nearly half of adults under 40—and nearly everyone over 40—exhibits signs of mitochondrial dysfunction, regardless of whether they “feel” tired. Creatine acts as a foundational energy buffer, moving beyond its reputation as a bodybuilding supplement to serve as a critical regulator for cellular stability, cognitive processing, and systemic longevity."
      ],
      "connections": [
        "Get muscle mass.ive",
        "Hold on to your strength"
      ],
      "url": "https://wellawarecare.substack.com/p/power-powder"
    },
    {
      "id": "Power up with potassium",
      "tldr": [
        "Potassium is a critical nutrient with a daily requirement of 4700 milligrams, far exceeding most people’s intake. ",
        "A deficiency in potassium can lead to muscle cramps, high blood pressure, and heart palpitations, among other issues. ",
        "Processed foods, high-carb diets, and certain medications can deplete potassium levels. ",
        "Including potassium-rich foods, hydrating properly, and being mindful during fasting can prevent serious imbalances."
      ],
      "connections": [
        "Your energy source",
        "Supplements for your pretty face",
        "Zinc it up",
        "When alcohol hits the cells",
        "Hack your fuel",
        "Hangovers",
        "Hold on to your strength",
        "Stress on purpose",
        "Damn hard without vitamin D"
      ],
      "url": "https://wellawarecare.substack.com/p/power-up-with-potassium"
    },
    {
      "id": "Prevent that cancer",
      "tldr": [
        "Fasting protocols like OMAD and 48-hour fasts help suppress cancer growth and enhance chemotherapy’s effectiveness. ",
        "Fasting reduces inflammation, promotes autophagy, and lowers IGF and mTOR levels, all key to cancer prevention. ",
        "Natural remedies like curcumin, garlic, and black seed oil complement fasting by inhibiting cancer growth. ",
        "Alcohol’s DNA-altering toxins increase cancer risks, especially for breast cancer. ",
        "Regular exercise combined with fasting lowers the risk of cancer and other chronic diseases."
      ],
      "connections": [
        "Ketogenic diet and cancer",
        "Non-food foods",
        "Take 11 minutes a day to postpone death",
        "The healthy hungry age better",
        "Don't de-health while deodorizing",
        "The real spice, girl!",
        "Nasties in beauty",
        "Alcohol & DNA",
        "Inflammation to cancer",
        "Starve that cancer",
        "Can't lose weight?",
        "Health we inherit"
      ],
      "url": "https://wellawarecare.substack.com/p/prevent-that-cancer"
    },
    {
      "id": "Preventing Alzheimer’s with lifestyle choices",
      "tldr": [
        "Up to 40% of Alzheimer’s cases are linked to modifiable lifestyle factors. ",
        "Factors like gender, diet, exercise, sleep, and metabolic health significantly impact Alzheimer’s risk. ",
        "Avoiding processed foods, supporting metabolic health, and eating brain-boosting nutrients like DHA from fish and antioxidants can reduce the risk of cognitive decline."
      ],
      "connections": [
        "Brain health 101",
        "Effects of mouth's proximity to the brain",
        "Non-food foods",
        "Hold on to your strength",
        "Detox with sleep",
        "Brainiac strategies for the brain",
        "Reorder mental disorder",
        "Insulin's hard problem"
      ],
      "url": "https://wellawarecare.substack.com/p/preventing-alzheimers-with-lifestyle"
    },
    {
      "id": "Push against gravity",
      "tldr": [
        "We think of gravity as background physics, but it’s an active biological force shaping mood, metabolism, and resilience. Every cell evolved under its pull, yet modern life minimizes exposure—chairs, shoes, and flights quietly erode our anti-gravity systems. The body weakens not from age alone but from disuse of the very force that keeps it upright."
      ],
      "connections": [
        "Be better than the conventional normal",
        "Get muscle mass.ive",
        "Hack your fuel",
        "Hold on to your strength"
      ],
      "url": "https://wellawarecare.substack.com/p/push-against-gravity"
    },
    {
      "id": "Quiet Fire",
      "tldr": [
        "Inflammation is often associated with injury or illness, yet most modern inflammation operates quietly. It persists without obvious symptoms, driven less by acute threats and more by ongoing system interactions—particularly between the gut, immune signaling, microbes, and metabolism. Understanding inflammation requires looking at how these elements stay connected long after the original trigger has passed."
      ],
      "connections": [
        "Hack your fuel",
        "Inflammation to cancer",
        "Inside job",
        "Joint pain",
        "Ketogenic diet and cancer",
        "Lactose in-tolerance?",
        "Lean mean double green",
        "Meat (head) and iron (maiden)",
        "Non-food foods",
        "Prevent that cancer"
      ],
      "url": "https://wellawarecare.substack.com/p/quiet-fire"
    },
    {
      "id": "Reorder mental disorder",
      "tldr": [
        "Mental disorders often stem from metabolic dysfunction, particularly mitochondrial impairment. ",
        "Trauma survivors frequently suffer from mitochondrial imbalances, leading to both physical and mental health challenges. ",
        "Medications for mental disorders can harm mitochondrial function, causing side effects like weight gain and diabetes. ",
        "A whole food, low-glycemic diet, potentially ketogenic, supports mitochondrial repair and mental health. ",
        "Neurons and glial cells have distinct energy preferences, and balancing them can optimize brain function."
      ],
      "connections": [
        "Brain health 101",
        "Effects of mouth's proximity to the brain",
        "Welcome the suck",
        "Detox with sleep",
        "Fermented food benefits",
        "Brainiac strategies for the brain",
        "Complexities of depression",
        "Health we inherit"
      ],
      "url": "https://wellawarecare.substack.com/p/reorder-mental-disorder"
    },
    {
      "id": "Right brain is right",
      "tldr": [
        "The right brain is our lifelong anchor for emotion, safety, and connection—and it matures in the first 24 months of life. ",
        "Attachment isn’t just psychological. It’s psychobiological, shaping how we regulate emotional arousal via the autonomic nervous system. ",
        "Regulation theory reveals that intimacy, eye contact, music, and even scent can rewire our nervous system and heal attachment wounds. ",
        "Empathy is more than a concept. It’s a full-body, right-brain-to-right-brain resonance—and texting can’t replicate it. ",
        "Trust, safety, and emotional transformation happen in spontaneous, embodied, co-regulated exchanges—not in emoji."
      ],
      "connections": [
        "Socialized wellness",
        "Brainiac strategies for the brain",
        "Reorder mental disorder"
      ],
      "url": "https://wellawarecare.substack.com/p/right-brain-is-right"
    },
    {
      "id": "Rot is in the air",
      "tldr": [
        "Mold is not just a moisture problem—it’s a chronic health disruptor hiding in dust, HVAC systems, and furniture. ",
        "Indoor air can be up to 100x more polluted than outdoor air due to synthetic materials, poor ventilation, and off-gassing. ",
        "Dead mold still causes reactions; most remediation misses spores, dust, and HVAC infiltration. ",
        "Particles and VOCs (volatile organic compounds) pass into the bloodstream through inhalation and impact everything from immunity to cognition. ",
        "Detoxification starts with prevention: filter your air, sweat often, upgrade your bedding, and let your liver work, not fight."
      ],
      "connections": [
        "Functional medicine functioning",
        "Don't de-health while deodorizing",
        "Master of detox"
      ],
      "url": "https://wellawarecare.substack.com/p/rot-is-in-the-air"
    },
    {
      "id": "Smell it out",
      "tldr": [
        "Smell and taste subconsciously shape social interactions, from pheromone detection to trust-building. ",
        "Gender differences and hormonal shifts play a key role in odor perception and relationship dynamics. ",
        "Chemical exchanges via breath, skin, and touch guide human decisions and deepen connections. ",
        "Handshakes, shared spaces, and tears involve chemical sensing, influencing interpersonal bonds. ",
        "Sensory behaviors, though subtle, have profound effects on everyday life, including partner selection and trust."
      ],
      "connections": [
        "Bonds, alpha females & botox"
      ],
      "url": "https://wellawarecare.substack.com/p/smell-it-out"
    },
    {
      "id": "Socialized wellness",
      "tldr": [
        "Relationships are a central, underappreciated driver of both health and longevity. ",
        "Social genomics shows our gene expression shifts depending on the quality of our relationships—love dampens inflammation, conflict fans its flames. ",
        "The quality of your social circle affects your risk of obesity, chronic disease, depression, and even early death. ",
        "Deep emotional connections—like those felt when calling someone to share good news—regulate our physiology and even synchronize heart and brain waves. ",
        "Being in a bad relationship, or lacking meaningful friendships, increases disease risk as much as smoking or poor diet."
      ],
      "connections": [
        "Smell it out",
        "Bonds, alpha females & botox",
        "Brain health 101"
      ],
      "url": "https://wellawarecare.substack.com/p/socialized-wellness"
    },
    {
      "id": "Spermi got nerdy",
      "tldr": [
        "Spermidine is a naturally occurring postbiotic and polyamine essential for cell survival, longevity, and autophagy. ",
        "It mimics and enables fasting by triggering autophagy, mitophagy, and cellular renewal. ",
        "Spermidine levels decline with age and are difficult to replenish adequately through diet alone. ",
        "Supplementation improves mitochondrial function, supports brain and kidney health, and reduces inflammation. ",
        "Topical spermidine has shown benefits for collagen production, skin tone, and hair growth."
      ],
      "connections": [
        "Master of detox",
        "Level up your gut!",
        "One third of your youth",
        "Supplements for your pretty face",
        "Your energy source"
      ],
      "url": "https://wellawarecare.substack.com/p/spermi-got-nerdy"
    },
    {
      "id": "Starve that cancer",
      "tldr": [
        "Ketogenic diets and fasting are emerging as effective tools in cancer prevention and treatment. ",
        "Ketosis inhibits cancer growth, reduces inflammation, and enhances cell renewal via autophagy. ",
        "Pairing chemotherapy with ketosis shows promise in improving treatment outcomes. ",
        "Lifestyle factors like sleep, light exposure, and emotional well-being are vital in cancer prevention. ",
        "Optimizing mitochondrial health and adopting holistic practices ensure long-term wellness."
      ],
      "connections": [
        "Ketogenic diet and cancer",
        "Non-food foods",
        "Take 11 minutes a day to postpone death",
        "The healthy hungry age better",
        "Don't de-health while deodorizing",
        "The real spice, girl!",
        "Inflammation to cancer",
        "Nasties in beauty",
        "Prevent that cancer",
        "Alcohol & DNA",
        "Can't lose weight?",
        "Health we inherit"
      ],
      "url": "https://wellawarecare.substack.com/p/starve-that-cancer"
    },
    {
      "id": "Stress on purpose",
      "tldr": [
        "Stress isn’t the enemy; improper recovery is. Embrace hormesis – purposeful stress like fasting, exercise, and cold exposure – to strengthen the body and mind. ",
        "Mitochondria, your cellular powerhouses, produce 16x more energy in the presence of oxygen. Aging accelerates with hypoxia. ",
        "The aggressive pursuit of comfort speeds up aging. Stress adaptation (e.g., through sprinting, fasting, cold exposure) unlocks resilience. ",
        "Sleep quality directly impacts longevity. Your brain’s glymphatic system clears waste and inflammation during deep sleep. ",
        "Nutrient deficiencies, not genetics, drive most chronic diseases. Identify and supplement deficiencies to regain health."
      ],
      "connections": [
        "Your energy source",
        "Hold on to your strength",
        "High performance sleeping"
      ],
      "url": "https://wellawarecare.substack.com/p/stress-on-purpose"
    },
    {
      "id": "Super sea food",
      "tldr": [
        "Modern environmental stressors place an unprecedented load on the body's natural detoxification and energy pathways. While often dismissed as a generic superfood, spirulina and chlorella are biologically distinct organisms that function as systemic \"cleaners\" and \"rechargers.\" These algae provide a nutrient density 1,000 times greater than any other fruit or vegetable, offering a mechanical solution to cellular inflammation and toxic accumulation."
      ],
      "connections": [
        "Lean mean double green"
      ],
      "url": "https://wellawarecare.substack.com/p/super-sea-food"
    },
    {
      "id": "Supplementation is not expensive urine",
      "tldr": [
        "Foundational supplements provide essential nutrients, digestive enzymes, and adaptogens to bridge dietary gaps. ",
        "Single-ingredient formulations target specific deficiencies with precision and avoid unnecessary compounds. ",
        "Balance fat-soluble (A, D, E, K) and water-soluble vitamins to optimize health and prevent toxicity. ",
        "Gut health support through probiotics, prebiotics, and digestive enzymes enhances nutrient absorption and overall wellness. ",
        "Tailor supplementation to your lifestyle, diet, and unique needs for maximum benefit."
      ],
      "connections": [
        "Power up with potassium",
        "Supplements for your pretty face",
        "Brain health 101",
        "Damn hard without vitamin D",
        "Vitamin D Deficiency"
      ],
      "url": "https://wellawarecare.substack.com/p/supplementation-is-not-expensive-urine"
    },
    {
      "id": "Supplements for your pretty face",
      "tldr": [
        "Mitochondria are your body’s energy factories, and supporting their function is crucial for anti-aging and vitality. ",
        "Glutathione not only detoxifies your liver but also strengthens mitochondrial health. ",
        "Clean beauty products can reduce exposure to hormonal disruptors, supporting both skin and hormonal balance. ",
        "By focusing on mitochondrial health and clean beauty, you can boost energy, improve skin, and enhance overall well-being."
      ],
      "connections": [
        "One third of your youth",
        "Don't de-health while deodorizing",
        "Bonds, alpha females & botox",
        "Your energy source",
        "Femme fatale fragrance",
        "Nasties in beauty",
        "Master of detox",
        "Supplementation is not expensive urine",
        "Damn hard without vitamin D",
        "Lactose in-tolerance?",
        "Zinc it up"
      ],
      "url": "https://wellawarecare.substack.com/p/supplements-for-your-pretty-face"
    },
    {
      "id": "Sweet and salty sugar",
      "tldr": [
        "Neuropod cells in the gut communicate with the brain, influencing sugar cravings and dopamine release. ",
        "Hidden sugars in foods can trick your taste buds and drive overconsumption. ",
        "Glycemic Index (GI) impacts sugar cravings, with lower-GI foods moderating blood sugar spikes and dopamine response. ",
        "Strategies like fiber pairing and low-GI choices help manage sugar cravings and stabilize energy. ",
        "Omega-3 fatty acids and glutamine may reduce sugar cravings by influencing gut-brain communication."
      ],
      "connections": [
        "Non-food foods",
        "Your energy source",
        "Fruit juice to fatty liver",
        "Be better than the conventional normal",
        "Starve that cancer",
        "Less (eating) is more (healthy)",
        "No sweet dreams with sweets"
      ],
      "url": "https://wellawarecare.substack.com/p/sweet-and-salty-sugar"
    },
    {
      "id": "Take 11 minutes a day to postpone death",
      "tldr": [
        "Regular exercise is the most potent natural remedy for living longer and reducing disease risk. ",
        "Building a \"fitness reserve\" gives your body a health buffer to counter stress, improve metabolism, and enhance flexibility. ",
        "Short bursts of high-intensity exercise throughout the day can dramatically lower mortality rates and reduce risks of cardiovascular disease and cancer. ",
        "Activities like walking after meals, using tools like the Relentless Rope Trainer and mobility sticks, and even sauna sessions can boost fitness and support overall well-being. ",
        "Consistency in enjoyable fitness activities and using heart rate variability (HRV) technology to monitor stress and recovery can optimize exercise routines."
      ],
      "connections": [
        "Your energy source",
        "Hold on to your strength"
      ],
      "url": "https://wellawarecare.substack.com/p/take-11-minutes-a-day-to-postpone"
    },
    {
      "id": "The dark light",
      "tldr": [
        "You’ve been taught to fear sunlight and ignore indoor light. You protect your skin, dim your screens, and assume light only matters when you can see it. But most of what shapes your cells is invisible. Different wavelengths of light are absorbed, reflected, or scattered through your body—changing how your mitochondria work, how your eyes age, and how your metabolism responds."
      ],
      "connections": [
        "Out of focus",
        "Vitamin D Deficiency"
      ],
      "url": "https://wellawarecare.substack.com/p/the-dark-light"
    },
    {
      "id": "The genetic disconnect",
      "tldr": [
        "Our genes remain largely unchanged for 250,000 years, yet modern life introduces stressors that our bodies aren't designed to handle. ",
        "Epigenetics, influenced by diet and environment, determines how genes are expressed and can affect future generations. ",
        "Environmental toxins, such as plastics and phthalates, disrupt hormones and gene expression, contributing to health challenges like infertility and cognitive decline. ",
        "mRNA and CRISPR technologies are revolutionizing genetic science but carry unknown long-term risks. ",
        "Managing environmental and lifestyle factors is essential for adapting to modern challenges and maintaining genetic health."
      ],
      "connections": [
        "Preventing Alzheimer’s with lifestyle choices",
        "Femme fatale fragrance",
        "Brain health 101",
        "Insulin's hard problem",
        "Inflammation to cancer",
        "Nasties in beauty"
      ],
      "url": "https://wellawarecare.substack.com/p/the-genetic-disconnect"
    },
    {
      "id": "The healthy hungry age better",
      "tldr": [
        "Fasting is not only safe but essential for older adults, offering numerous benefits like life extension and activation of anti-aging genes. ",
        "It helps alleviate age-related health issues such as obesity, high blood pressure, and dementia by promoting metabolic flexibility. ",
        "Fasting supports DNA and mitochondrial repair through autophagy, enhancing cellular function and reducing cancer risk. ",
        "It boosts heart and brain health by increasing ketone production and stimulating neuronal regeneration with BDNF. ",
        "The practice enhances the body's antioxidant network, reducing free radical damage and supporting cardiovascular health."
      ],
      "connections": [
        "How does fasting affect hormones?",
        "Brain health 101",
        "Your energy source",
        "Less (eating) is more (healthy)",
        "Faster weight loss on slow thyroid",
        "When to eat?",
        "Hack your fuel"
      ],
      "url": "https://wellawarecare.substack.com/p/the-healthy-hungry-age-better"
    },
    {
      "id": "The real spice, girl!",
      "tldr": [
        "Turmeric, used in ancient medicine, contains curcumin, a powerful polyphenol with poor natural absorption. ",
        "For better absorption, pair turmeric with black pepper or supplements containing bioparen. ",
        "Curcumin reduces dementia risk, supports brain health, alleviates joint pain, and even fights cancer. ",
        "Turmeric aids women’s health by improving mood and managing PMS symptoms. ",
        "High-polyphenol spices like turmeric promote gut health and weight management."
      ],
      "connections": [
        "Brain health 101",
        "Level up your gut!",
        "Prevent that cancer",
        "Inflammation to cancer",
        "Hack your fuel"
      ],
      "url": "https://wellawarecare.substack.com/p/the-real-spice-girl"
    },
    {
      "id": "The sugar consequences of salt",
      "tldr": [
        "Fructose is produced in the liver when glucose is high and causes insulin resistance, leading to fat gain and metabolic syndrome. ",
        "High salt intake without enough water triggers fructose production and fat storage, contributing to metabolic problems. ",
        "Fructose and certain foods raise uric acid levels, causing oxidative stress and a cycle of increased fructose production, worsening obesity. ",
        "High fructose and uric acid levels damage blood vessels, making arterial plaque stickier and increasing heart disease risk."
      ],
      "connections": [
        "Your energy source",
        "Fruit juice to fatty liver",
        "One third of your youth",
        "Non-food foods",
        "Starve that cancer",
        "Hold on to your strength"
      ],
      "url": "https://wellawarecare.substack.com/p/the-sugar-consequences-of-salt"
    },
    {
      "id": "Toxic traditions",
      "tldr": [
        "Many modern rituals introduce large, short-term toxin spikes into air, water, and soil—often without awareness or consent. Fireworks, wildfire smoke, and industrial chemicals don’t act in isolation. They interact with lungs, blood, brain, and endocrine systems, creating cumulative effects that persist long after the event itself ends. Understanding toxin exposure requires seeing how cultural practices and environmental chemistry intersect."
      ],
      "connections": [
        "Effects of mouth's proximity to the brain",
        "Explosive & toxic chemicals in food",
        "Femme fatale fragrance",
        "Lean mean double green",
        "Master of detox",
        "Rot is in the air",
        "Don't de-health while deodorizing"
      ],
      "url": "https://wellawarecare.substack.com/p/toxic-traditions"
    },
    {
      "id": "Unmanned man",
      "tldr": [
        "A generation of men feels aimless, addicted, or disconnected not because they’re weak, but because they’ve lost touch with their _Why_. When reward becomes easier than effort, and stimulation replaces purpose, the brain stops pushing forward. Addiction, distraction, and numbness aren’t failures of discipline, they’re signs of a mind that has stopped believing its actions matter."
      ],
      "connections": [
        "Grit, Glucose & Grind",
        "Socialized wellness",
        "Y make a man",
        "Be better than the conventional normal",
        "Welcome the suck"
      ],
      "url": "https://wellawarecare.substack.com/p/unmanned-man"
    },
    {
      "id": "Vampire queen",
      "tldr": [
        "When estrogen begins to fade, the brain feels it first. Energy falls, heat rises, and clarity flickers. It can feel like the light is draining out—but this isn’t decay; it’s conversion. The menopausal brain stops feeding on the old fuel and learns to make its own. The same networks that once depended on hormonal energy start reorganizing for endurance. Understanding this shift turns menopause from a story of loss into one of transformation."
      ],
      "connections": [
        "Functional medicine functioning",
        "Master of detox",
        "Supplements for your pretty face"
      ],
      "url": "https://wellawarecare.substack.com/p/vampire-queen"
    },
    {
      "id": "Vitamin D Deficiency",
      "tldr": [
        "Supplement vitamin D through food when sunlight is insufficient. ",
        "Darker skin requires more sunlight. ",
        "Symptoms of vitamin D deficiency include bone loss, pain, low immunity, depression, high blood pressure, and inflammation. ",
        "Additionally, there are over 20 lesser-known symptoms, such as nightmares, acne, and vertigo.  "
      ],
      "connections": [
        "Be better than the conventional normal",
        "Explosive & toxic chemicals in food",
        "Functional medicine functioning",
        "Supplementation is not expensive urine",
        "Nasties in beauty",
        "Hold on to your strength",
        "Damn hard without vitamin D"
      ],
      "url": "https://wellawarecare.substack.com/p/care-10-vitamin-d-deficiency"
    },
    {
      "id": "Welcome the suck",
      "tldr": [
        "Happiness is a balance of enjoyment, satisfaction, and meaning, and is processed differently in the brain. ",
        "Struggling, deferred gratification, and effort are necessary components of long-term satisfaction. ",
        "Suffering is essential for growth and self-awareness, and embracing it can lead to a deeper sense of happiness. ",
        "Deep relationships, meaningful work, and teaching others play critical roles in achieving happiness and mastery."
      ],
      "connections": [
        "How does fasting affect hormones?",
        "Reorder mental disorder"
      ],
      "url": "https://wellawarecare.substack.com/p/welcome-the-suck"
    },
    {
      "id": "When alcohol hits the cells",
      "tldr": [
        "Alcohol penetrates every cell due to its water- and fat-soluble nature, causing widespread effects. ",
        "Even low alcohol intake (1-2 drinks/day) can thin the neocortex, a brain region vital for memory and self-regulation. ",
        "Regular drinkers feel prolonged euphoria due to neural changes, while occasional drinkers experience quicker cognitive declines. ",
        "High alcohol consumption (12+ drinks/week) is strongly tied to neurodegeneration. ",
        "Starting to drink young dramatically increases the risk of alcohol dependence. ",
        "Alcohol transforms into toxic byproducts like acetaldehyde, disrupting cellular and neural health."
      ],
      "connections": [
        "Brain health 101",
        "Alcohol & DNA",
        "Blackouts",
        "Hangovers",
        "Brainiac strategies for the brain"
      ],
      "url": "https://wellawarecare.substack.com/p/when-alcohol-hits-the-cells"
    },
    {
      "id": "When to eat?",
      "tldr": [
        "When you eat is as important as what you eat for health, especially liver and mental health. ",
        "Time-restricted feeding (TRF) helps align your body's 24-hour rhythm (circadian clock), boosting health and reducing risks. ",
        "Eating during your active phase of the day (daylight hours) enhances metabolic health and prevents liver damage. ",
        "Short feeding windows (4–6 hours) may increase overeating, while 7–9 hour windows show consistent health benefits. ",
        "Fasting impacts brain and body, supporting clarity, hormone balance, and fat loss when coupled with caloric restriction."
      ],
      "connections": [
        "How does fasting affect hormones?",
        "The healthy hungry age better",
        "Hack your fuel",
        "Less (eating) is more (healthy)",
        "Stress on purpose"
      ],
      "url": "https://wellawarecare.substack.com/p/when-to-eat"
    },
    {
      "id": "Working workout",
      "tldr": [
        "Foundational health requires a mechanical mix of \"Zone 2\" aerobic work for mitochondrial density and \"Vigorous\" intervals for cardiovascular capacity (VO2 Max). Missing either node leaves the system without the structural overhead to manage metabolic stress or prevent physiological decay."
      ],
      "connections": [
        "Brainiac strategies for the brain",
        "Get muscle mass.ive",
        "High performance sleeping",
        "Prevent that cancer",
        "Preventing Alzheimer’s with lifestyle choices",
        "Stress on purpose",
        "Take 11 minutes a day to postpone death"
      ],
      "url": "https://wellawarecare.substack.com/p/working-workout"
    },
    {
      "id": "Y make a man",
      "tldr": [
        "The Y chromosome decides more than sex. It flips a switch before birth that tells the body to make testosterone, build testes, and wire the brain in a certain way. That early signal shapes how we move, think, and react long after we’re born. Understanding what the Y does—and what happens when its signal changes—explains many of the real differences between male and female brains."
      ],
      "connections": [
        "Belly fat!",
        "Master of detox",
        "Detox with sleep"
      ],
      "url": "https://wellawarecare.substack.com/p/y-make-a-man"
    },
    {
      "id": "Your energy source",
      "tldr": [
        "Mitochondria are your body’s energy producers, converting food and oxygen into ATP, the fuel for all cellular functions. ",
        "Damage to mitochondria, often caused by oxidative stress and environmental toxins, leads to fatigue, memory loss, and rapid aging. ",
        "Reducing sugar, processed foods, and toxins can protect mitochondria and enhance energy levels. ",
        "Exercise, especially interval training and strength training, along with antioxidant-rich plant foods, support mitochondrial health. ",
        "Key supplements like CoQ10, resveratrol, and omega-3s can further boost mitochondrial function and energy production."
      ],
      "connections": [
        "Explosive & toxic chemicals in food",
        "Functional medicine functioning",
        "Fruit juice to fatty liver",
        "Power up with potassium",
        "Ketogenic diet and cancer",
        "Take 11 minutes a day to postpone death",
        "The healthy hungry age better",
        "Be better than the conventional normal",
        "Faster weight loss on slow thyroid",
        "Supplements for your pretty face",
        "Supplementation is not expensive urine",
        "Zinc it up",
        "Fermented food benefits",
        "Insulin's hard problem",
        "Master of detox"
      ],
      "url": "https://wellawarecare.substack.com/p/your-energy-source"
    },
    {
      "id": "Zinc it up",
      "tldr": [
        "Zinc is essential for over 300 enzymatic reactions, impacting everything from hormones to skin health. ",
        "Zinc deficiency can manifest as digestive issues, mood changes, and low testosterone. ",
        "Supplementing with zinc and eating zinc-rich foods helps support cognitive function, hormone balance, and sleep. ",
        "Prioritize zinc to enhance your immune system, improve skin health, and boost overall well-being."
      ],
      "connections": [
        "Your energy source",
        "Be better than the conventional normal",
        "High performance sleeping",
        "Bread!",
        "Level up your gut!",
        "Power up with potassium",
        "Supplements for your pretty face",
        "Damn hard without vitamin D"
      ],
      "url": "https://wellawarecare.substack.com/p/zinc-it-up"
    }
  ],
  "links": [
    {
      "source": "Addiction friction",
      "target": "Sweet and salty sugar"
    },
    {
      "source": "Addiction friction",
      "target": "Unmanned man"
    },
    {
      "source": "Addiction friction",
      "target": "Out of focus"
    },
    {
      "source": "Addiction friction",
      "target": "Brain health 101"
    },
    {
      "source": "Addiction friction",
      "target": "Brainiac strategies for the brain"
    },
    {
      "source": "Addiction friction",
      "target": "Mind at volume"
    },
    {
      "source": "Addiction friction",
      "target": "Socialized wellness"
    },
    {
      "source": "Alcohol & DNA",
      "target": "Level up your gut!"
    },
    {
      "source": "Alcohol & DNA",
      "target": "Non-food foods"
    },
    {
      "source": "Alcohol & DNA",
      "target": "The genetic disconnect"
    },
    {
      "source": "Alcohol & DNA",
      "target": "Prevent that cancer"
    },
    {
      "source": "Alcohol & DNA",
      "target": "Fermented food benefits"
    },
    {
      "source": "Alcohol & DNA",
      "target": "Supplementation is not expensive urine"
    },
    {
      "source": "Alcohol & DNA",
      "target": "Hack your fuel"
    },
    {
      "source": "Alcohol & DNA",
      "target": "Hangovers"
    },
    {
      "source": "Alcohol & DNA",
      "target": "When alcohol hits the cells"
    },
    {
      "source": "Alcohol & DNA",
      "target": "Blackouts"
    },
    {
      "source": "Be better than the conventional normal",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Be better than the conventional normal",
      "target": "Power up with potassium"
    },
    {
      "source": "Be better than the conventional normal",
      "target": "High performance sleeping"
    },
    {
      "source": "Be better than the conventional normal",
      "target": "Zinc it up"
    },
    {
      "source": "Belly fat!",
      "target": "Bread!"
    },
    {
      "source": "Belly fat!",
      "target": "One third of your youth"
    },
    {
      "source": "Belly fat!",
      "target": "High performance sleeping"
    },
    {
      "source": "Belly fat!",
      "target": "Less (eating) is more (healthy)"
    },
    {
      "source": "Belly fat!",
      "target": "Damn hard without vitamin D"
    },
    {
      "source": "Belly fat!",
      "target": "No sweet dreams with sweets"
    },
    {
      "source": "Blackouts",
      "target": "Brain health 101"
    },
    {
      "source": "Blackouts",
      "target": "When alcohol hits the cells"
    },
    {
      "source": "Blackouts",
      "target": "Alcohol & DNA"
    },
    {
      "source": "Bonds, alpha females & botox",
      "target": "Nasties in beauty"
    },
    {
      "source": "Brain health 101",
      "target": "Effects of mouth's proximity to the brain"
    },
    {
      "source": "Brain health 101",
      "target": "Welcome the suck"
    },
    {
      "source": "Brain health 101",
      "target": "Non-food foods"
    },
    {
      "source": "Brain health 101",
      "target": "High performance sleeping"
    },
    {
      "source": "Brain health 101",
      "target": "Power up with potassium"
    },
    {
      "source": "Brain health 101",
      "target": "Preventing Alzheimer’s with lifestyle choices"
    },
    {
      "source": "Brain health 101",
      "target": "The healthy hungry age better"
    },
    {
      "source": "Brain health 101",
      "target": "Zinc it up"
    },
    {
      "source": "Brain health 101",
      "target": "Reorder mental disorder"
    },
    {
      "source": "Brain health 101",
      "target": "Sweet and salty sugar"
    },
    {
      "source": "Brain health 101",
      "target": "Detox with sleep"
    },
    {
      "source": "Brainiac strategies for the brain",
      "target": "Non-food foods"
    },
    {
      "source": "Brainiac strategies for the brain",
      "target": "The sugar consequences of salt"
    },
    {
      "source": "Brainiac strategies for the brain",
      "target": "Take 11 minutes a day to postpone death"
    },
    {
      "source": "Brainiac strategies for the brain",
      "target": "Sweet and salty sugar"
    },
    {
      "source": "Brainiac strategies for the brain",
      "target": "Insulin's hard problem"
    },
    {
      "source": "Brainiac strategies for the brain",
      "target": "Hold on to your strength"
    },
    {
      "source": "Bread!",
      "target": "The real spice, girl!"
    },
    {
      "source": "Bread!",
      "target": "Belly fat!"
    },
    {
      "source": "Bread!",
      "target": "How does fasting affect hormones?"
    },
    {
      "source": "Bread!",
      "target": "How do you like them apples?"
    },
    {
      "source": "Bread!",
      "target": "High performance sleeping"
    },
    {
      "source": "Can't lose weight?",
      "target": "Functional medicine functioning"
    },
    {
      "source": "Can't lose weight?",
      "target": "The real spice, girl!"
    },
    {
      "source": "Can't lose weight?",
      "target": "Belly fat!"
    },
    {
      "source": "Can't lose weight?",
      "target": "Level up your gut!"
    },
    {
      "source": "Can't lose weight?",
      "target": "Fruit juice to fatty liver"
    },
    {
      "source": "Can't lose weight?",
      "target": "Faster weight loss on slow thyroid"
    },
    {
      "source": "Can't lose weight?",
      "target": "Nasties in beauty"
    },
    {
      "source": "Can't lose weight?",
      "target": "Hack your fuel"
    },
    {
      "source": "Can't lose weight?",
      "target": "Pick not Ozempic"
    },
    {
      "source": "Can't lose weight?",
      "target": "When to eat?"
    },
    {
      "source": "Can't lose weight?",
      "target": "Functional medicine functioning"
    },
    {
      "source": "Comfy crash",
      "target": "Crave brain rave"
    },
    {
      "source": "Comfy crash",
      "target": "Hack your fuel"
    },
    {
      "source": "Comfy crash",
      "target": "Power up with potassium"
    },
    {
      "source": "Comfy crash",
      "target": "Preventing Alzheimer’s with lifestyle choices"
    },
    {
      "source": "Comfy crash",
      "target": "Socialized wellness"
    },
    {
      "source": "Complexities of depression",
      "target": "Brain health 101"
    },
    {
      "source": "Complexities of depression",
      "target": "Non-food foods"
    },
    {
      "source": "Complexities of depression",
      "target": "Damn hard without vitamin D"
    },
    {
      "source": "Complexities of depression",
      "target": "Detox with sleep"
    },
    {
      "source": "Complexities of depression",
      "target": "Reorder mental disorder"
    },
    {
      "source": "Complexities of depression",
      "target": "Health we inherit"
    },
    {
      "source": "Crave brain rave",
      "target": "Your energy source"
    },
    {
      "source": "Crave brain rave",
      "target": "Non-food foods"
    },
    {
      "source": "Crave brain rave",
      "target": "Insulin's hard problem"
    },
    {
      "source": "Crave brain rave",
      "target": "Reorder mental disorder"
    },
    {
      "source": "Crave brain rave",
      "target": "Starve that cancer"
    },
    {
      "source": "Crave brain rave",
      "target": "Sweet and salty sugar"
    },
    {
      "source": "Crave brain rave",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Crave brain rave",
      "target": "Preventing Alzheimer’s with lifestyle choices"
    },
    {
      "source": "Crystal clear pain",
      "target": "Forged in iron"
    },
    {
      "source": "Crystal clear pain",
      "target": "Joint pain"
    },
    {
      "source": "Crystal clear pain",
      "target": "How does fasting affect hormones?"
    },
    {
      "source": "Crystal clear pain",
      "target": "Level up your gut!"
    },
    {
      "source": "Damn hard without vitamin D",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "Damn hard without vitamin D",
      "target": "Functional medicine functioning"
    },
    {
      "source": "Damn hard without vitamin D",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Damn hard without vitamin D",
      "target": "Vitamin D Deficiency"
    },
    {
      "source": "Damn hard without vitamin D",
      "target": "Hold on to your strength"
    },
    {
      "source": "Detox with sleep",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "Detox with sleep",
      "target": "High performance sleeping"
    },
    {
      "source": "Detox with sleep",
      "target": "Preventing Alzheimer’s with lifestyle choices"
    },
    {
      "source": "Detox with sleep",
      "target": "Brain health 101"
    },
    {
      "source": "Don't de-health while deodorizing",
      "target": "Femme fatale fragrance"
    },
    {
      "source": "Don't de-health while deodorizing",
      "target": "Ketogenic diet and cancer"
    },
    {
      "source": "Don't de-health while deodorizing",
      "target": "How does fasting affect hormones?"
    },
    {
      "source": "Don't de-health while deodorizing",
      "target": "Nasties in beauty"
    },
    {
      "source": "Don't de-health while deodorizing",
      "target": "The genetic disconnect"
    },
    {
      "source": "Don't de-health while deodorizing",
      "target": "Starve that cancer"
    },
    {
      "source": "Eating electronics",
      "target": "Nasties in beauty"
    },
    {
      "source": "Eating electronics",
      "target": "The genetic disconnect"
    },
    {
      "source": "Eating electronics",
      "target": "How does fasting affect hormones?"
    },
    {
      "source": "Eating electronics",
      "target": "Is organic food worth it?"
    },
    {
      "source": "Effects of mouth's proximity to the brain",
      "target": "Non-food foods"
    },
    {
      "source": "Effects of mouth's proximity to the brain",
      "target": "Preventing Alzheimer’s with lifestyle choices"
    },
    {
      "source": "Effects of mouth's proximity to the brain",
      "target": "Brain health 101"
    },
    {
      "source": "Effects of mouth's proximity to the brain",
      "target": "Less (eating) is more (healthy)"
    },
    {
      "source": "Effects of mouth's proximity to the brain",
      "target": "Nasties in beauty"
    },
    {
      "source": "Effects of mouth's proximity to the brain",
      "target": "Hold on to your strength"
    },
    {
      "source": "Effects of mouth's proximity to the brain",
      "target": "Detox with sleep"
    },
    {
      "source": "Explosive & toxic chemicals in food",
      "target": "Bread!"
    },
    {
      "source": "Explosive & toxic chemicals in food",
      "target": "Is organic food worth it?"
    },
    {
      "source": "Explosive & toxic chemicals in food",
      "target": "Level up your gut!"
    },
    {
      "source": "Explosive & toxic chemicals in food",
      "target": "Femme fatale fragrance"
    },
    {
      "source": "Explosive & toxic chemicals in food",
      "target": "Functional medicine functioning"
    },
    {
      "source": "Explosive & toxic chemicals in food",
      "target": "Your energy source"
    },
    {
      "source": "Explosive & toxic chemicals in food",
      "target": "Damn hard without vitamin D"
    },
    {
      "source": "Faster weight loss on slow thyroid",
      "target": "How does fasting affect hormones?"
    },
    {
      "source": "Faster weight loss on slow thyroid",
      "target": "Functional medicine functioning"
    },
    {
      "source": "Faster weight loss on slow thyroid",
      "target": "How do you like them apples?"
    },
    {
      "source": "Faster weight loss on slow thyroid",
      "target": "Level up your gut!"
    },
    {
      "source": "Faster weight loss on slow thyroid",
      "target": "Less (eating) is more (healthy)"
    },
    {
      "source": "Femme fatale fragrance",
      "target": "Don't de-health while deodorizing"
    },
    {
      "source": "Femme fatale fragrance",
      "target": "Nasties in beauty"
    },
    {
      "source": "Femme fatale fragrance",
      "target": "The genetic disconnect"
    },
    {
      "source": "Femme fatale fragrance",
      "target": "Master of detox"
    },
    {
      "source": "Fermented food benefits",
      "target": "The real spice, girl!"
    },
    {
      "source": "Fermented food benefits",
      "target": "Level up your gut!"
    },
    {
      "source": "Fermented food benefits",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Fermented food benefits",
      "target": "How do you like them apples?"
    },
    {
      "source": "Fermented food benefits",
      "target": "Non-food foods"
    },
    {
      "source": "Fermented food benefits",
      "target": "Supplementation is not expensive urine"
    },
    {
      "source": "Fermented food benefits",
      "target": "Hack your fuel"
    },
    {
      "source": "Filter with liver",
      "target": "Can't lose weight?"
    },
    {
      "source": "Filter with liver",
      "target": "When alcohol hits the cells"
    },
    {
      "source": "Filter with liver",
      "target": "Level up your gut!"
    },
    {
      "source": "Filter with liver",
      "target": "Inside job"
    },
    {
      "source": "Filter with liver",
      "target": "Rot is in the air"
    },
    {
      "source": "Filter with liver",
      "target": "Fruit juice to fatty liver"
    },
    {
      "source": "Filter with liver",
      "target": "One third of your youth"
    },
    {
      "source": "Filter with liver",
      "target": "The sugar consequences of salt"
    },
    {
      "source": "Filter with liver",
      "target": "When to eat?"
    },
    {
      "source": "Focus stacking",
      "target": "Filter with liver"
    },
    {
      "source": "Focus stacking",
      "target": "Level up your gut!"
    },
    {
      "source": "Focus stacking",
      "target": "Super sea food"
    },
    {
      "source": "Focus stacking",
      "target": "No sweet dreams with sweets"
    },
    {
      "source": "Forged in iron",
      "target": "Zinc it up"
    },
    {
      "source": "Fruit juice to fatty liver",
      "target": "The sugar consequences of salt"
    },
    {
      "source": "Fruit juice to fatty liver",
      "target": "One third of your youth"
    },
    {
      "source": "Fruit juice to fatty liver",
      "target": "Is organic food worth it?"
    },
    {
      "source": "Fruit juice to fatty liver",
      "target": "Less (eating) is more (healthy)"
    },
    {
      "source": "Fruit juice to fatty liver",
      "target": "When to eat?"
    },
    {
      "source": "Fruit juice to fatty liver",
      "target": "Starve that cancer"
    },
    {
      "source": "Fruit juice to fatty liver",
      "target": "Insulin's hard problem"
    },
    {
      "source": "Fruit juice to fatty liver",
      "target": "Can't lose weight?"
    },
    {
      "source": "Full of full fat",
      "target": "Alcohol & DNA"
    },
    {
      "source": "Full of full fat",
      "target": "Belly fat!"
    },
    {
      "source": "Full of full fat",
      "target": "Can't lose weight?"
    },
    {
      "source": "Full of full fat",
      "target": "Faster weight loss on slow thyroid"
    },
    {
      "source": "Full of full fat",
      "target": "Filter with liver"
    },
    {
      "source": "Full of full fat",
      "target": "Hack your fuel"
    },
    {
      "source": "Full of full fat",
      "target": "How do you like them apples?"
    },
    {
      "source": "Full of full fat",
      "target": "Is organic food worth it?"
    },
    {
      "source": "Full of full fat",
      "target": "The sugar consequences of salt"
    },
    {
      "source": "Full of full fat",
      "target": "When to eat?"
    },
    {
      "source": "Functional medicine functioning",
      "target": "Your energy source"
    },
    {
      "source": "Get muscle mass.ive",
      "target": "Meat (head) and iron (maiden)"
    },
    {
      "source": "Get muscle mass.ive",
      "target": "Hack your fuel"
    },
    {
      "source": "Get muscle mass.ive",
      "target": "Hold on to your strength"
    },
    {
      "source": "Get muscle mass.ive",
      "target": "Stress on purpose"
    },
    {
      "source": "Get muscle mass.ive",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "Get muscle mass.ive",
      "target": "Power up with potassium"
    },
    {
      "source": "Get muscle mass.ive",
      "target": "Your energy source"
    },
    {
      "source": "Grit, Glucose & Grind",
      "target": "Hack your fuel"
    },
    {
      "source": "Grit, Glucose & Grind",
      "target": "Detox with sleep"
    },
    {
      "source": "Grit, Glucose & Grind",
      "target": "Get muscle mass.ive"
    },
    {
      "source": "Grit, Glucose & Grind",
      "target": "Stress on purpose"
    },
    {
      "source": "Hack your fuel",
      "target": "Your energy source"
    },
    {
      "source": "Hack your fuel",
      "target": "Power up with potassium"
    },
    {
      "source": "Hack your fuel",
      "target": "The healthy hungry age better"
    },
    {
      "source": "Hack your fuel",
      "target": "Less (eating) is more (healthy)"
    },
    {
      "source": "Hack your fuel",
      "target": "Stress on purpose"
    },
    {
      "source": "Hack your fuel",
      "target": "When to eat?"
    },
    {
      "source": "Hangovers",
      "target": "Power up with potassium"
    },
    {
      "source": "Hangovers",
      "target": "Level up your gut!"
    },
    {
      "source": "Hangovers",
      "target": "Supplementation is not expensive urine"
    },
    {
      "source": "Hangovers",
      "target": "Alcohol & DNA"
    },
    {
      "source": "Hangovers",
      "target": "Hack your fuel"
    },
    {
      "source": "Hangovers",
      "target": "Fermented food benefits"
    },
    {
      "source": "Hangovers",
      "target": "Inflammation to cancer"
    },
    {
      "source": "Hangovers",
      "target": "When alcohol hits the cells"
    },
    {
      "source": "Hangovers",
      "target": "Blackouts"
    },
    {
      "source": "Health we inherit",
      "target": "Your energy source"
    },
    {
      "source": "Health we inherit",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Health we inherit",
      "target": "The genetic disconnect"
    },
    {
      "source": "Health we inherit",
      "target": "Reorder mental disorder"
    },
    {
      "source": "Health we inherit",
      "target": "Brainiac strategies for the brain"
    },
    {
      "source": "High performance sleeping",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "High performance sleeping",
      "target": "How does fasting affect hormones?"
    },
    {
      "source": "High performance sleeping",
      "target": "One third of your youth"
    },
    {
      "source": "High performance sleeping",
      "target": "Detox with sleep"
    },
    {
      "source": "High performance sleeping",
      "target": "Hold on to your strength"
    },
    {
      "source": "High performance sleeping",
      "target": "No sweet dreams with sweets"
    },
    {
      "source": "High performance sleeping",
      "target": "Zinc it up"
    },
    {
      "source": "High performance sleeping",
      "target": "Brainiac strategies for the brain"
    },
    {
      "source": "Hold on to your strength",
      "target": "Power up with potassium"
    },
    {
      "source": "Hold on to your strength",
      "target": "Take 11 minutes a day to postpone death"
    },
    {
      "source": "Hold on to your strength",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "Hold on to your strength",
      "target": "Damn hard without vitamin D"
    },
    {
      "source": "How do you like them apples?",
      "target": "Functional medicine functioning"
    },
    {
      "source": "How do you like them apples?",
      "target": "Level up your gut!"
    },
    {
      "source": "How do you like them apples?",
      "target": "Belly fat!"
    },
    {
      "source": "How do you like them apples?",
      "target": "The healthy hungry age better"
    },
    {
      "source": "How do you like them apples?",
      "target": "Hack your fuel"
    },
    {
      "source": "How does fasting affect hormones?",
      "target": "The healthy hungry age better"
    },
    {
      "source": "How does fasting affect hormones?",
      "target": "High performance sleeping"
    },
    {
      "source": "How does fasting affect hormones?",
      "target": "Faster weight loss on slow thyroid"
    },
    {
      "source": "How does fasting affect hormones?",
      "target": "Zinc it up"
    },
    {
      "source": "How does fasting affect hormones?",
      "target": "Less (eating) is more (healthy)"
    },
    {
      "source": "How does fasting affect hormones?",
      "target": "Insulin's hard problem"
    },
    {
      "source": "How does fasting affect hormones?",
      "target": "Hack your fuel"
    },
    {
      "source": "How does fasting affect hormones?",
      "target": "Detox with sleep"
    },
    {
      "source": "Inflammation to cancer",
      "target": "Your energy source"
    },
    {
      "source": "Inflammation to cancer",
      "target": "Ketogenic diet and cancer"
    },
    {
      "source": "Inflammation to cancer",
      "target": "Non-food foods"
    },
    {
      "source": "Inflammation to cancer",
      "target": "Prevent that cancer"
    },
    {
      "source": "Inflammation to cancer",
      "target": "Starve that cancer"
    },
    {
      "source": "Inflammation to cancer",
      "target": "The genetic disconnect"
    },
    {
      "source": "Input equals IQ",
      "target": "Forged in iron"
    },
    {
      "source": "Input equals IQ",
      "target": "Hack your fuel"
    },
    {
      "source": "Input equals IQ",
      "target": "Brain health 101"
    },
    {
      "source": "Input equals IQ",
      "target": "Brainiac strategies for the brain"
    },
    {
      "source": "Input equals IQ",
      "target": "Detox with sleep"
    },
    {
      "source": "Input equals IQ",
      "target": "Preventing Alzheimer’s with lifestyle choices"
    },
    {
      "source": "Inside job",
      "target": "Fermented food benefits"
    },
    {
      "source": "Inside job",
      "target": "How do you like them apples?"
    },
    {
      "source": "Inside job",
      "target": "Level up your gut!"
    },
    {
      "source": "Inside job",
      "target": "Non-food foods"
    },
    {
      "source": "Insulin's hard problem",
      "target": "How does fasting affect hormones?"
    },
    {
      "source": "Insulin's hard problem",
      "target": "One third of your youth"
    },
    {
      "source": "Insulin's hard problem",
      "target": "The sugar consequences of salt"
    },
    {
      "source": "Insulin's hard problem",
      "target": "Faster weight loss on slow thyroid"
    },
    {
      "source": "Insulin's hard problem",
      "target": "Less (eating) is more (healthy)"
    },
    {
      "source": "Insulin's hard problem",
      "target": "Hack your fuel"
    },
    {
      "source": "Insulin's hard problem",
      "target": "Stress on purpose"
    },
    {
      "source": "Is organic food worth it?",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Is organic food worth it?",
      "target": "Level up your gut!"
    },
    {
      "source": "Is organic food worth it?",
      "target": "Functional medicine functioning"
    },
    {
      "source": "Is organic food worth it?",
      "target": "Your energy source"
    },
    {
      "source": "Is organic food worth it?",
      "target": "Non-food foods"
    },
    {
      "source": "Joint pain",
      "target": "Insulin's hard problem"
    },
    {
      "source": "Joint pain",
      "target": "Detox with sleep"
    },
    {
      "source": "Joint pain",
      "target": "Hack your fuel"
    },
    {
      "source": "Joint pain",
      "target": "Level up your gut!"
    },
    {
      "source": "Joint pain",
      "target": "How do you like them apples?"
    },
    {
      "source": "Joint pain",
      "target": "Comfy crash"
    },
    {
      "source": "Joint pain",
      "target": "The real spice, girl!"
    },
    {
      "source": "Ketogenic diet and cancer",
      "target": "Functional medicine functioning"
    },
    {
      "source": "Ketogenic diet and cancer",
      "target": "The real spice, girl!"
    },
    {
      "source": "Ketogenic diet and cancer",
      "target": "Preventing Alzheimer’s with lifestyle choices"
    },
    {
      "source": "Ketogenic diet and cancer",
      "target": "Take 11 minutes a day to postpone death"
    },
    {
      "source": "Ketogenic diet and cancer",
      "target": "The healthy hungry age better"
    },
    {
      "source": "Ketogenic diet and cancer",
      "target": "Your energy source"
    },
    {
      "source": "Ketogenic diet and cancer",
      "target": "Starve that cancer"
    },
    {
      "source": "Ketogenic diet and cancer",
      "target": "Prevent that cancer"
    },
    {
      "source": "Ketogenic diet and cancer",
      "target": "Inflammation to cancer"
    },
    {
      "source": "Ketogenic diet and cancer",
      "target": "Detox with sleep"
    },
    {
      "source": "Lactose in-tolerance?",
      "target": "Level up your gut!"
    },
    {
      "source": "Lactose in-tolerance?",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Lactose in-tolerance?",
      "target": "Vitamin D Deficiency"
    },
    {
      "source": "Lactose in-tolerance?",
      "target": "Damn hard without vitamin D"
    },
    {
      "source": "Lean mean double green",
      "target": "Your energy source"
    },
    {
      "source": "Lean mean double green",
      "target": "Non-food foods"
    },
    {
      "source": "Lean mean double green",
      "target": "Master of detox"
    },
    {
      "source": "Lean mean double green",
      "target": "One third of your youth"
    },
    {
      "source": "Less (eating) is more (healthy)",
      "target": "Faster weight loss on slow thyroid"
    },
    {
      "source": "Less (eating) is more (healthy)",
      "target": "The healthy hungry age better"
    },
    {
      "source": "Less (eating) is more (healthy)",
      "target": "Your energy source"
    },
    {
      "source": "Less (eating) is more (healthy)",
      "target": "Belly fat!"
    },
    {
      "source": "Less (eating) is more (healthy)",
      "target": "How does fasting affect hormones?"
    },
    {
      "source": "Less (eating) is more (healthy)",
      "target": "Level up your gut!"
    },
    {
      "source": "Less (eating) is more (healthy)",
      "target": "Prevent that cancer"
    },
    {
      "source": "Less (eating) is more (healthy)",
      "target": "Starve that cancer"
    },
    {
      "source": "Level up your gut!",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Level up your gut!",
      "target": "Level up your gut!"
    },
    {
      "source": "Level up your gut!",
      "target": "Bread!"
    },
    {
      "source": "Level up your gut!",
      "target": "Is organic food worth it?"
    },
    {
      "source": "Level up your gut!",
      "target": "Non-food foods"
    },
    {
      "source": "Level up your gut!",
      "target": "Lactose in-tolerance?"
    },
    {
      "source": "Level up your gut!",
      "target": "Fermented food benefits"
    },
    {
      "source": "Level up your gut!",
      "target": "Supplementation is not expensive urine"
    },
    {
      "source": "Life lemon duo",
      "target": "Mind at volume"
    },
    {
      "source": "Life lemon duo",
      "target": "Health we inherit"
    },
    {
      "source": "Life lemon duo",
      "target": "Reorder mental disorder"
    },
    {
      "source": "Life lemon duo",
      "target": "Right brain is right"
    },
    {
      "source": "Life lemon duo",
      "target": "Complexities of depression"
    },
    {
      "source": "Master of detox",
      "target": "Supplements for your pretty face"
    },
    {
      "source": "Master of detox",
      "target": "Femme fatale fragrance"
    },
    {
      "source": "Master of detox",
      "target": "Don't de-health while deodorizing"
    },
    {
      "source": "Master of detox",
      "target": "Nasties in beauty"
    },
    {
      "source": "Master of detox",
      "target": "The genetic disconnect"
    },
    {
      "source": "Master of detox",
      "target": "Zinc it up"
    },
    {
      "source": "Meat (head) and iron (maiden)",
      "target": "Hack your fuel"
    },
    {
      "source": "Meat (head) and iron (maiden)",
      "target": "Is organic food worth it?"
    },
    {
      "source": "Meat (head) and iron (maiden)",
      "target": "Lactose in-tolerance?"
    },
    {
      "source": "Meat (head) and iron (maiden)",
      "target": "Pick not Ozempic"
    },
    {
      "source": "Mind at volume",
      "target": "Life lemon duo"
    },
    {
      "source": "Mind at volume",
      "target": "Brain health 101"
    },
    {
      "source": "Nasties in beauty",
      "target": "Femme fatale fragrance"
    },
    {
      "source": "Nasties in beauty",
      "target": "Bonds, alpha females & botox"
    },
    {
      "source": "Nasties in beauty",
      "target": "The real spice, girl!"
    },
    {
      "source": "Nasties in beauty",
      "target": "The genetic disconnect"
    },
    {
      "source": "No sweet dreams with sweets",
      "target": "High performance sleeping"
    },
    {
      "source": "No sweet dreams with sweets",
      "target": "Non-food foods"
    },
    {
      "source": "No sweet dreams with sweets",
      "target": "The sugar consequences of salt"
    },
    {
      "source": "No sweet dreams with sweets",
      "target": "Detox with sleep"
    },
    {
      "source": "No sweet dreams with sweets",
      "target": "Sweet and salty sugar"
    },
    {
      "source": "Non-food foods",
      "target": "The sugar consequences of salt"
    },
    {
      "source": "Non-food foods",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Non-food foods",
      "target": "Is organic food worth it?"
    },
    {
      "source": "Non-food foods",
      "target": "Level up your gut!"
    },
    {
      "source": "Non-food foods",
      "target": "Brain health 101"
    },
    {
      "source": "Non-food foods",
      "target": "Your energy source"
    },
    {
      "source": "Non-food foods",
      "target": "Power up with potassium"
    },
    {
      "source": "Non-food foods",
      "target": "Prevent that cancer"
    },
    {
      "source": "Non-food foods",
      "target": "Starve that cancer"
    },
    {
      "source": "One third of your youth",
      "target": "Your energy source"
    },
    {
      "source": "One third of your youth",
      "target": "Supplements for your pretty face"
    },
    {
      "source": "One third of your youth",
      "target": "Level up your gut!"
    },
    {
      "source": "One third of your youth",
      "target": "High performance sleeping"
    },
    {
      "source": "One third of your youth",
      "target": "Fermented food benefits"
    },
    {
      "source": "One third of your youth",
      "target": "The genetic disconnect"
    },
    {
      "source": "One third of your youth",
      "target": "Hack your fuel"
    },
    {
      "source": "One third of your youth",
      "target": "Master of detox"
    },
    {
      "source": "One third of your youth",
      "target": "Detox with sleep"
    },
    {
      "source": "Out of focus",
      "target": "Damn hard without vitamin D"
    },
    {
      "source": "Out of focus",
      "target": "Inside job"
    },
    {
      "source": "Peaked at 25",
      "target": "Working workout"
    },
    {
      "source": "Peaked at 25",
      "target": "Get muscle mass.ive"
    },
    {
      "source": "Peaked at 25",
      "target": "Power powder"
    },
    {
      "source": "Peaked at 25",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "Peaked at 25",
      "target": "Hack your fuel"
    },
    {
      "source": "Peaked at 25",
      "target": "Stress on purpose"
    },
    {
      "source": "Pick not Ozempic",
      "target": "Your energy source"
    },
    {
      "source": "Pick not Ozempic",
      "target": "Hold on to your strength"
    },
    {
      "source": "Power powder",
      "target": "Get muscle mass.ive"
    },
    {
      "source": "Power powder",
      "target": "Hold on to your strength"
    },
    {
      "source": "Power up with potassium",
      "target": "Your energy source"
    },
    {
      "source": "Power up with potassium",
      "target": "Supplements for your pretty face"
    },
    {
      "source": "Power up with potassium",
      "target": "Zinc it up"
    },
    {
      "source": "Power up with potassium",
      "target": "When alcohol hits the cells"
    },
    {
      "source": "Power up with potassium",
      "target": "Hack your fuel"
    },
    {
      "source": "Power up with potassium",
      "target": "Hangovers"
    },
    {
      "source": "Power up with potassium",
      "target": "Hold on to your strength"
    },
    {
      "source": "Power up with potassium",
      "target": "Stress on purpose"
    },
    {
      "source": "Power up with potassium",
      "target": "Damn hard without vitamin D"
    },
    {
      "source": "Prevent that cancer",
      "target": "Ketogenic diet and cancer"
    },
    {
      "source": "Prevent that cancer",
      "target": "Non-food foods"
    },
    {
      "source": "Prevent that cancer",
      "target": "Take 11 minutes a day to postpone death"
    },
    {
      "source": "Prevent that cancer",
      "target": "The healthy hungry age better"
    },
    {
      "source": "Prevent that cancer",
      "target": "Don't de-health while deodorizing"
    },
    {
      "source": "Prevent that cancer",
      "target": "The real spice, girl!"
    },
    {
      "source": "Prevent that cancer",
      "target": "Nasties in beauty"
    },
    {
      "source": "Prevent that cancer",
      "target": "Alcohol & DNA"
    },
    {
      "source": "Prevent that cancer",
      "target": "Inflammation to cancer"
    },
    {
      "source": "Prevent that cancer",
      "target": "Starve that cancer"
    },
    {
      "source": "Prevent that cancer",
      "target": "Can't lose weight?"
    },
    {
      "source": "Prevent that cancer",
      "target": "Health we inherit"
    },
    {
      "source": "Preventing Alzheimer’s with lifestyle choices",
      "target": "Brain health 101"
    },
    {
      "source": "Preventing Alzheimer’s with lifestyle choices",
      "target": "Effects of mouth's proximity to the brain"
    },
    {
      "source": "Preventing Alzheimer’s with lifestyle choices",
      "target": "Non-food foods"
    },
    {
      "source": "Preventing Alzheimer’s with lifestyle choices",
      "target": "Hold on to your strength"
    },
    {
      "source": "Preventing Alzheimer’s with lifestyle choices",
      "target": "Detox with sleep"
    },
    {
      "source": "Preventing Alzheimer’s with lifestyle choices",
      "target": "Brainiac strategies for the brain"
    },
    {
      "source": "Preventing Alzheimer’s with lifestyle choices",
      "target": "Reorder mental disorder"
    },
    {
      "source": "Preventing Alzheimer’s with lifestyle choices",
      "target": "Insulin's hard problem"
    },
    {
      "source": "Push against gravity",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "Push against gravity",
      "target": "Get muscle mass.ive"
    },
    {
      "source": "Push against gravity",
      "target": "Hack your fuel"
    },
    {
      "source": "Push against gravity",
      "target": "Hold on to your strength"
    },
    {
      "source": "Quiet Fire",
      "target": "Hack your fuel"
    },
    {
      "source": "Quiet Fire",
      "target": "Inflammation to cancer"
    },
    {
      "source": "Quiet Fire",
      "target": "Inside job"
    },
    {
      "source": "Quiet Fire",
      "target": "Joint pain"
    },
    {
      "source": "Quiet Fire",
      "target": "Ketogenic diet and cancer"
    },
    {
      "source": "Quiet Fire",
      "target": "Lactose in-tolerance?"
    },
    {
      "source": "Quiet Fire",
      "target": "Lean mean double green"
    },
    {
      "source": "Quiet Fire",
      "target": "Meat (head) and iron (maiden)"
    },
    {
      "source": "Quiet Fire",
      "target": "Non-food foods"
    },
    {
      "source": "Quiet Fire",
      "target": "Prevent that cancer"
    },
    {
      "source": "Reorder mental disorder",
      "target": "Brain health 101"
    },
    {
      "source": "Reorder mental disorder",
      "target": "Effects of mouth's proximity to the brain"
    },
    {
      "source": "Reorder mental disorder",
      "target": "Welcome the suck"
    },
    {
      "source": "Reorder mental disorder",
      "target": "Detox with sleep"
    },
    {
      "source": "Reorder mental disorder",
      "target": "Fermented food benefits"
    },
    {
      "source": "Reorder mental disorder",
      "target": "Brainiac strategies for the brain"
    },
    {
      "source": "Reorder mental disorder",
      "target": "Complexities of depression"
    },
    {
      "source": "Reorder mental disorder",
      "target": "Health we inherit"
    },
    {
      "source": "Right brain is right",
      "target": "Socialized wellness"
    },
    {
      "source": "Right brain is right",
      "target": "Brainiac strategies for the brain"
    },
    {
      "source": "Right brain is right",
      "target": "Reorder mental disorder"
    },
    {
      "source": "Rot is in the air",
      "target": "Functional medicine functioning"
    },
    {
      "source": "Rot is in the air",
      "target": "Don't de-health while deodorizing"
    },
    {
      "source": "Rot is in the air",
      "target": "Master of detox"
    },
    {
      "source": "Smell it out",
      "target": "Bonds, alpha females & botox"
    },
    {
      "source": "Socialized wellness",
      "target": "Smell it out"
    },
    {
      "source": "Socialized wellness",
      "target": "Bonds, alpha females & botox"
    },
    {
      "source": "Socialized wellness",
      "target": "Brain health 101"
    },
    {
      "source": "Spermi got nerdy",
      "target": "Master of detox"
    },
    {
      "source": "Spermi got nerdy",
      "target": "Level up your gut!"
    },
    {
      "source": "Spermi got nerdy",
      "target": "One third of your youth"
    },
    {
      "source": "Spermi got nerdy",
      "target": "Supplements for your pretty face"
    },
    {
      "source": "Spermi got nerdy",
      "target": "Your energy source"
    },
    {
      "source": "Starve that cancer",
      "target": "Ketogenic diet and cancer"
    },
    {
      "source": "Starve that cancer",
      "target": "Non-food foods"
    },
    {
      "source": "Starve that cancer",
      "target": "Take 11 minutes a day to postpone death"
    },
    {
      "source": "Starve that cancer",
      "target": "The healthy hungry age better"
    },
    {
      "source": "Starve that cancer",
      "target": "Don't de-health while deodorizing"
    },
    {
      "source": "Starve that cancer",
      "target": "The real spice, girl!"
    },
    {
      "source": "Starve that cancer",
      "target": "Inflammation to cancer"
    },
    {
      "source": "Starve that cancer",
      "target": "Nasties in beauty"
    },
    {
      "source": "Starve that cancer",
      "target": "Prevent that cancer"
    },
    {
      "source": "Starve that cancer",
      "target": "Alcohol & DNA"
    },
    {
      "source": "Starve that cancer",
      "target": "Can't lose weight?"
    },
    {
      "source": "Starve that cancer",
      "target": "Health we inherit"
    },
    {
      "source": "Stress on purpose",
      "target": "Your energy source"
    },
    {
      "source": "Stress on purpose",
      "target": "Hold on to your strength"
    },
    {
      "source": "Stress on purpose",
      "target": "High performance sleeping"
    },
    {
      "source": "Super sea food",
      "target": "Lean mean double green"
    },
    {
      "source": "Supplementation is not expensive urine",
      "target": "Power up with potassium"
    },
    {
      "source": "Supplementation is not expensive urine",
      "target": "Supplements for your pretty face"
    },
    {
      "source": "Supplementation is not expensive urine",
      "target": "Brain health 101"
    },
    {
      "source": "Supplementation is not expensive urine",
      "target": "Damn hard without vitamin D"
    },
    {
      "source": "Supplementation is not expensive urine",
      "target": "Vitamin D Deficiency"
    },
    {
      "source": "Supplements for your pretty face",
      "target": "One third of your youth"
    },
    {
      "source": "Supplements for your pretty face",
      "target": "Don't de-health while deodorizing"
    },
    {
      "source": "Supplements for your pretty face",
      "target": "Bonds, alpha females & botox"
    },
    {
      "source": "Supplements for your pretty face",
      "target": "Your energy source"
    },
    {
      "source": "Supplements for your pretty face",
      "target": "Femme fatale fragrance"
    },
    {
      "source": "Supplements for your pretty face",
      "target": "Nasties in beauty"
    },
    {
      "source": "Supplements for your pretty face",
      "target": "Master of detox"
    },
    {
      "source": "Supplements for your pretty face",
      "target": "Supplementation is not expensive urine"
    },
    {
      "source": "Supplements for your pretty face",
      "target": "Damn hard without vitamin D"
    },
    {
      "source": "Supplements for your pretty face",
      "target": "Lactose in-tolerance?"
    },
    {
      "source": "Supplements for your pretty face",
      "target": "Zinc it up"
    },
    {
      "source": "Sweet and salty sugar",
      "target": "Non-food foods"
    },
    {
      "source": "Sweet and salty sugar",
      "target": "Your energy source"
    },
    {
      "source": "Sweet and salty sugar",
      "target": "Fruit juice to fatty liver"
    },
    {
      "source": "Sweet and salty sugar",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "Sweet and salty sugar",
      "target": "Starve that cancer"
    },
    {
      "source": "Sweet and salty sugar",
      "target": "Less (eating) is more (healthy)"
    },
    {
      "source": "Sweet and salty sugar",
      "target": "No sweet dreams with sweets"
    },
    {
      "source": "Take 11 minutes a day to postpone death",
      "target": "Your energy source"
    },
    {
      "source": "Take 11 minutes a day to postpone death",
      "target": "Hold on to your strength"
    },
    {
      "source": "The dark light",
      "target": "Out of focus"
    },
    {
      "source": "The dark light",
      "target": "Vitamin D Deficiency"
    },
    {
      "source": "The genetic disconnect",
      "target": "Preventing Alzheimer’s with lifestyle choices"
    },
    {
      "source": "The genetic disconnect",
      "target": "Femme fatale fragrance"
    },
    {
      "source": "The genetic disconnect",
      "target": "Brain health 101"
    },
    {
      "source": "The genetic disconnect",
      "target": "Insulin's hard problem"
    },
    {
      "source": "The genetic disconnect",
      "target": "Inflammation to cancer"
    },
    {
      "source": "The genetic disconnect",
      "target": "Nasties in beauty"
    },
    {
      "source": "The healthy hungry age better",
      "target": "How does fasting affect hormones?"
    },
    {
      "source": "The healthy hungry age better",
      "target": "Brain health 101"
    },
    {
      "source": "The healthy hungry age better",
      "target": "Your energy source"
    },
    {
      "source": "The healthy hungry age better",
      "target": "Less (eating) is more (healthy)"
    },
    {
      "source": "The healthy hungry age better",
      "target": "Faster weight loss on slow thyroid"
    },
    {
      "source": "The healthy hungry age better",
      "target": "When to eat?"
    },
    {
      "source": "The healthy hungry age better",
      "target": "Hack your fuel"
    },
    {
      "source": "The real spice, girl!",
      "target": "Brain health 101"
    },
    {
      "source": "The real spice, girl!",
      "target": "Level up your gut!"
    },
    {
      "source": "The real spice, girl!",
      "target": "Prevent that cancer"
    },
    {
      "source": "The real spice, girl!",
      "target": "Inflammation to cancer"
    },
    {
      "source": "The real spice, girl!",
      "target": "Hack your fuel"
    },
    {
      "source": "The sugar consequences of salt",
      "target": "Your energy source"
    },
    {
      "source": "The sugar consequences of salt",
      "target": "Fruit juice to fatty liver"
    },
    {
      "source": "The sugar consequences of salt",
      "target": "One third of your youth"
    },
    {
      "source": "The sugar consequences of salt",
      "target": "Non-food foods"
    },
    {
      "source": "The sugar consequences of salt",
      "target": "Starve that cancer"
    },
    {
      "source": "The sugar consequences of salt",
      "target": "Hold on to your strength"
    },
    {
      "source": "Toxic traditions",
      "target": "Effects of mouth's proximity to the brain"
    },
    {
      "source": "Toxic traditions",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Toxic traditions",
      "target": "Femme fatale fragrance"
    },
    {
      "source": "Toxic traditions",
      "target": "Lean mean double green"
    },
    {
      "source": "Toxic traditions",
      "target": "Master of detox"
    },
    {
      "source": "Toxic traditions",
      "target": "Rot is in the air"
    },
    {
      "source": "Toxic traditions",
      "target": "Don't de-health while deodorizing"
    },
    {
      "source": "Unmanned man",
      "target": "Grit, Glucose & Grind"
    },
    {
      "source": "Unmanned man",
      "target": "Socialized wellness"
    },
    {
      "source": "Unmanned man",
      "target": "Y make a man"
    },
    {
      "source": "Unmanned man",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "Unmanned man",
      "target": "Welcome the suck"
    },
    {
      "source": "Vampire queen",
      "target": "Functional medicine functioning"
    },
    {
      "source": "Vampire queen",
      "target": "Master of detox"
    },
    {
      "source": "Vampire queen",
      "target": "Supplements for your pretty face"
    },
    {
      "source": "Vitamin D Deficiency",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "Vitamin D Deficiency",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Vitamin D Deficiency",
      "target": "Functional medicine functioning"
    },
    {
      "source": "Vitamin D Deficiency",
      "target": "Supplementation is not expensive urine"
    },
    {
      "source": "Vitamin D Deficiency",
      "target": "Nasties in beauty"
    },
    {
      "source": "Vitamin D Deficiency",
      "target": "Hold on to your strength"
    },
    {
      "source": "Vitamin D Deficiency",
      "target": "Damn hard without vitamin D"
    },
    {
      "source": "Welcome the suck",
      "target": "How does fasting affect hormones?"
    },
    {
      "source": "Welcome the suck",
      "target": "Reorder mental disorder"
    },
    {
      "source": "When alcohol hits the cells",
      "target": "Brain health 101"
    },
    {
      "source": "When alcohol hits the cells",
      "target": "Alcohol & DNA"
    },
    {
      "source": "When alcohol hits the cells",
      "target": "Blackouts"
    },
    {
      "source": "When alcohol hits the cells",
      "target": "Hangovers"
    },
    {
      "source": "When alcohol hits the cells",
      "target": "Brainiac strategies for the brain"
    },
    {
      "source": "When to eat?",
      "target": "How does fasting affect hormones?"
    },
    {
      "source": "When to eat?",
      "target": "The healthy hungry age better"
    },
    {
      "source": "When to eat?",
      "target": "Hack your fuel"
    },
    {
      "source": "When to eat?",
      "target": "Less (eating) is more (healthy)"
    },
    {
      "source": "When to eat?",
      "target": "Stress on purpose"
    },
    {
      "source": "Working workout",
      "target": "Brainiac strategies for the brain"
    },
    {
      "source": "Working workout",
      "target": "Get muscle mass.ive"
    },
    {
      "source": "Working workout",
      "target": "High performance sleeping"
    },
    {
      "source": "Working workout",
      "target": "Prevent that cancer"
    },
    {
      "source": "Working workout",
      "target": "Preventing Alzheimer’s with lifestyle choices"
    },
    {
      "source": "Working workout",
      "target": "Stress on purpose"
    },
    {
      "source": "Working workout",
      "target": "Take 11 minutes a day to postpone death"
    },
    {
      "source": "Y make a man",
      "target": "Belly fat!"
    },
    {
      "source": "Y make a man",
      "target": "Master of detox"
    },
    {
      "source": "Y make a man",
      "target": "Detox with sleep"
    },
    {
      "source": "Your energy source",
      "target": "Explosive & toxic chemicals in food"
    },
    {
      "source": "Your energy source",
      "target": "Functional medicine functioning"
    },
    {
      "source": "Your energy source",
      "target": "Fruit juice to fatty liver"
    },
    {
      "source": "Your energy source",
      "target": "Power up with potassium"
    },
    {
      "source": "Your energy source",
      "target": "Ketogenic diet and cancer"
    },
    {
      "source": "Your energy source",
      "target": "Take 11 minutes a day to postpone death"
    },
    {
      "source": "Your energy source",
      "target": "The healthy hungry age better"
    },
    {
      "source": "Your energy source",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "Your energy source",
      "target": "Faster weight loss on slow thyroid"
    },
    {
      "source": "Your energy source",
      "target": "Supplements for your pretty face"
    },
    {
      "source": "Your energy source",
      "target": "Supplementation is not expensive urine"
    },
    {
      "source": "Your energy source",
      "target": "Zinc it up"
    },
    {
      "source": "Your energy source",
      "target": "Fermented food benefits"
    },
    {
      "source": "Your energy source",
      "target": "Insulin's hard problem"
    },
    {
      "source": "Your energy source",
      "target": "Master of detox"
    },
    {
      "source": "Zinc it up",
      "target": "Your energy source"
    },
    {
      "source": "Zinc it up",
      "target": "Be better than the conventional normal"
    },
    {
      "source": "Zinc it up",
      "target": "High performance sleeping"
    },
    {
      "source": "Zinc it up",
      "target": "Bread!"
    },
    {
      "source": "Zinc it up",
      "target": "Level up your gut!"
    },
    {
      "source": "Zinc it up",
      "target": "Power up with potassium"
    },
    {
      "source": "Zinc it up",
      "target": "Supplements for your pretty face"
    },
    {
      "source": "Zinc it up",
      "target": "Damn hard without vitamin D"
    }
  ]
}